// @ts-ignore
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** Integers that will have a value greater than 0. */
  PositiveInt: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
};



export type AccountMenu = {
  __typename?: 'AccountMenu';
  loggedInMenu: Array<AccountMenuItem>;
  loggedOutMenu: Array<AccountMenuItem>;
};

export type AccountMenuItem = {
  __typename?: 'AccountMenuItem';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type AddAddressInput = {
  company?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  streetAddress2?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  stateShort?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  deliveryLocationType: DeliveryLocationType;
  /** The location name. Only used for click and collect and parcel lockers. Eg Kmart, Target, Richmond LPO */
  deliveryLocationName?: Maybe<Scalars['String']>;
  /** Set as primary/default address */
  defaultAddress: Scalars['Boolean'];
};

export type AddAddressResponse = Customer | UserError;

/** Add item to wishlist input */
export type AddItemToWishlistInput = {
  /** VariantId for the product being added to the wishlist */
  variantId: Scalars['ID'];
  /** Enables the user to be notified if product comes back in stock */
  notify?: Maybe<Scalars['Boolean']>;
};

export type AddItemsToCartInput = {
  items: Array<AddToCartInput>;
};

/** Consume OrderId and ParcelId to BuyAgain */
export type AddOrderToCartInput = {
  orderId: Scalars['ID'];
};

/** Returns Cart and buy again result */
export type AddOrderToCartResponse = {
  __typename?: 'AddOrderToCartResponse';
  cart: Cart;
  addOrderToCartResult: AddOrderToCartResult;
};

export type AddOrderToCartResult = {
  __typename?: 'AddOrderToCartResult';
  /** Products that failed to buy again */
  failList?: Maybe<Array<BuyAgainFailResultItem>>;
  /** Products that success to buy again */
  successList?: Maybe<Array<BuyAgainSuccessResultItem>>;
};

/** Add item to cart */
export type AddToCartInput = {
  eventId?: Maybe<Scalars['Int']>;
  shopSlug?: Maybe<Scalars['String']>;
  offerId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourcePosition?: Maybe<Scalars['Int']>;
  sourcePlatform?: Maybe<SourcePlatformType>;
  trigger?: Maybe<Trigger>;
  /** only use this for personalised product, e.g gift card */
  personalisedValues?: Maybe<Array<PersonalisedValueInput>>;
};

/** Address */
export type Address = {
  __typename?: 'Address';
  id: Scalars['ID'];
  company?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  streetAddress2?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  stateShort?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  deliveryLocationType: DeliveryLocationType;
  /** The location name. Only used for click and collect and parcel lockers. Eg Kmart, Target, Richmond LPO */
  deliveryLocationName?: Maybe<Scalars['String']>;
};

/**
 * Address book
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type AddressBook = {
  __typename?: 'AddressBook';
  /** owner(tribe: "Digital", squad: "conversion") */
  defaultAddress?: Maybe<Address>;
  /** owner(tribe: "Digital", squad: "conversion") */
  addresses: Array<Address>;
};

export type AnalyticVendorConfiguration = {
  enabled?: Maybe<Scalars['Boolean']>;
};

/** Namespace for all frontend analytics configuration */
export type Analytics = {
  __typename?: 'Analytics';
  snowplow: SnowplowConfiguration;
  gtm: GtmConfiguration;
  branchio: BranchIoConfiguration;
};


/** Namespace for all frontend analytics configuration */
export type AnalyticsSnowplowArgs = {
  input?: Maybe<SnowplowConfigurationInput>;
};

/**
 * A link for an app download from OS' app store
 * 
 * `owner(tribe: "CAL", squad: "LS")`
 */
export type AppDownloadLink = {
  __typename?: 'AppDownloadLink';
  /**
   * The name/identifier of the app store
   * 
   * `owner(tribe: "CAL", squad: "LS")`
   */
  name: Scalars['String'];
  /**
   * URL of the link
   * 
   * `owner(tribe: "CAL", squad: "LS")`
   */
  url: Scalars['String'];
};

/**
 * Banners are generally a page-wide image scheduled and typically links to another page either on the Catch website or externally.
 * Banners contain information such as title, subtitle, as well other generic high level data use to describe itself.
 * 
 *     `owner(tribe: "Digital", squad: "growth")`
 */
export type Banner = {
  __typename?: 'Banner';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /**
   * The URL the banner links to.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  url?: Maybe<Scalars['URL']>;
  /**
   * The title associated with the banner.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  title?: Maybe<Scalars['String']>;
  /**
   * Event banner image.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  image: Image;
  /**
   * This field is to be populated when an Event only has one product associated with it.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  platforms: Array<Platform>;
};

export type BannerByPageInput = {
  page?: Maybe<BannerPageType>;
};

export type BannerByPageResponse = {
  __typename?: 'BannerByPageResponse';
  banners: Array<Banner>;
};

export type BannerPageType = 
  | 'PRODUCT'
  | 'SEARCH';

export type BestSellerProductsInput = {
  categoryId?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type BestSellerProductsResponse = {
  __typename?: 'BestSellerProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

/** Response for deleting the customer */
export type BooleanResponse = {
  __typename?: 'BooleanResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

/** Configuration used to connect to BranchIO */
export type BranchIoConfiguration = AnalyticVendorConfiguration & {
  __typename?: 'BranchIOConfiguration';
  enabled: Scalars['Boolean'];
  bannerApiKey: Scalars['String'];
};

/**
 * Information for a specified brand, note that the name is a text value which can be created by sellers as required, meaning the data is not normalised.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type Brand = {
  __typename?: 'Brand';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "growth") */
  name: Scalars['String'];
  /**
   * Human readable unique string, generally used for resource location (URL).
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  slug: Scalars['String'];
  /**
   * The description of the brand in HTML.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  description?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "growth") */
  seoContent: SeoContent;
  /** owner(tribe: "Digital", squad: "growth") */
  image?: Maybe<Image>;
};

export type BrandByIdInput = {
  id: Scalars['ID'];
};

export type BrandRecommendedProductsInput = {
  productIds: Array<Scalars['ID']>;
  inStock?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type BrandRecommendedProductsResponse = {
  __typename?: 'BrandRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

export type BuyAgainFailResultItem = {
  __typename?: 'BuyAgainFailResultItem';
  /** Product title + error message */
  name: Scalars['String'];
  message: Scalars['String'];
};

export type BuyAgainMutationResponse = AddOrderToCartResponse | UserError | UnauthorisedUserError;

export type BuyAgainSuccessResultItem = {
  __typename?: 'BuyAgainSuccessResultItem';
  /** Product title + attrubite */
  offerId: Scalars['ID'];
  name: Scalars['String'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  attributeValue?: Maybe<Scalars['String']>;
  productSkuId?: Maybe<Scalars['ID']>;
};

/** Error response for Buy Now Cart update */
export type BuyNowCartError = Error & {
  __typename?: 'BuyNowCartError';
  code: BuyNowCartErrorCode;
  message: Scalars['String'];
};

/**
 * Error codes for Buy Now Cart
 * Note: when adding specific error codes (e.g. coupon errors) ensure the code is prefixed
 * with the thing it relates to (e.g. COUPON_INVALID).
 */
export type BuyNowCartErrorCode = 
  /** Generic Coupon Error. Check message for details. */
  | 'COUPON_ERROR'
  /** Generic Gift Card Error. Check message for details. */
  | 'GIFT_CARD_ERROR'
  /** Generic Payment Method Error. Check message for details. */
  | 'PAYMENT_METHOD_ERROR'
  /** Generic Parcel Error. Check message for details. */
  | 'PARCEL_ITEM_ERROR'
  /** Parcel item is unavailable. Either the item is out of stock or the requested quantity is unavailable. */
  | 'PARCEL_ITEM_UNAVAILABLE'
  /** Generic Shipping Option Error. Check message for details. */
  | 'SHIPPING_OPTION_ERROR'
  /** Generic Error. Check message for details. */
  | 'OTHER_ERROR'
  /** Generic submission error to be displayed to the user in a modal. See message for details. */
  | 'SUBMISSION_ERROR'
  /** Transaction timed out server-side. Client should re-submit the order. */
  | 'TIMEOUT_ERROR';

/** Namespace for CMS configuration */
export type CmsConfiguration = {
  __typename?: 'CMSConfiguration';
  header: HeaderConfiguration;
  /** Frontend analytics configuration */
  analytics: Analytics;
  /** Frontend OnePass configuration */
  onePass: OnePassConfiguration;
  /** Frontend page configuration */
  page: PageConfiguration;
};


/** Namespace for CMS configuration */
export type CmsConfigurationHeaderArgs = {
  input?: Maybe<HeaderConfigurationInput>;
};

/** Cart information for the current context user */
export type Cart = {
  __typename?: 'Cart';
  /** Identifier to assist data normalisation within Apollo cache */
  id: Scalars['ID'];
  /** Logical groupings within the cart */
  parcels: Array<CartParcel>;
  /** Informative messages or errors for the customer at the cart level (displayed at top) */
  notices: Array<CartNotice>;
  /** Information about pricing details of the overall cart */
  orderSummary: CartOrderSummary;
  /** Sum of item quantities inside cart (for use in Mini Cart) */
  itemsQuantitySum: Scalars['Int'];
  /** A manually applied coupon, if one has been applied to the cart */
  userCoupon?: Maybe<CartCoupon>;
  /** All details of the Club Catch subscription item to display in cart */
  clubSubscription: CartClubSubscription;
  /**
   * Selected shipping option
   * @deprecated Only for use by legacy iOS cart
   */
  selectedShippingOption?: Maybe<CartParcelShippingOption>;
  /**
   * List of shipping options on the cart
   * @deprecated Only for use by legacy iOS cart
   */
  shippingOptions: Array<CartParcelShippingOption>;
  /**
   * Information about pricing details of the cart exclude giftcard, and roundup
   * @deprecated Only for use by legacy iOS cart
   */
  legacyOrderSummary: LegacyCartOrderSummary;
  canProceedToCheckout: Scalars['Boolean'];
  /** Current selected cart shipping location. If location has not previously been specified, it will be inferred from either customer default address or geolocation */
  shippingLocation?: Maybe<CartShippingLocation>;
  /**
   * Fingerprint is a unique hash for the current state of the cart. If price, quantity, shipping costs or club catch status change, the hash will change
   * This is useful to detect if the cart has been updated on a different device, tab or window.
   * It is the responsibility of the client to monitor for changes to the fingerprint and display whatever notice may be appropriate to the customer.
   */
  fingerprint: Scalars['String'];
  /** Flags whether the cart is on a sales channel that supports gift card payments */
  giftCardSupported: Scalars['Boolean'];
  /** Flags whether the OnePass popup recommender should be displayed */
  showOnePassRecommender: Scalars['Boolean'];
};

/** Response for mutations that involve multiple items */
export type CartBatchMutationResponse = {
  __typename?: 'CartBatchMutationResponse';
  cart: Cart;
  errors: Array<Error>;
};

/**
 * Club Catch subscription item to display in the Cart
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type CartClubSubscription = {
  __typename?: 'CartClubSubscription';
  /**
   * All the club subscription options the user can select
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  options: Array<CartClubSubscriptionOption>;
  /**
   * The current chosen option selected by the user
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  selectedOption?: Maybe<CartClubSubscriptionOption>;
  /**
   * Cart ID
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  id?: Maybe<Scalars['ID']>;
  /**
   * Whether to offer Club Catch upsell within the delivery box
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   * @deprecated Only for use by legacy iOS cart
   */
  offerUpsell: Scalars['Boolean'];
};

export type CartClubSubscriptionOption = ClubSubscription & {
  __typename?: 'CartClubSubscriptionOption';
  /** A unique id for each club subscription; maps 1-1 with offer.id */
  id: Scalars['ID'];
  /** Price of the monthly or yearly subscription */
  price: Money;
  /** Billing interval */
  interval: ClubSubscriptionInterval;
  /** The Date the user will next be billed */
  nextBillingDate: Scalars['DateTime'];
  /** Whether or not the option is a free trial */
  freeTrial: Scalars['Boolean'];
  /** Title to display on the item */
  title: Scalars['String'];
  /** Subtitle including cost and expiry date */
  subtitle: Scalars['String'];
  /** The image to display in the parcel item */
  clubImage: Image;
};

export type CartCoPurchasedProducts = {
  __typename?: 'CartCoPurchasedProducts';
  product?: Maybe<Product>;
  metaData: RecommenderMetaData;
};

export type CartCoPurchasedProductsInput = {
  productIds: Array<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttributes?: Maybe<Scalars['Boolean']>;
  excludedProductIds?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
};

/** A coupon applied to the Cart */
export type CartCoupon = {
  __typename?: 'CartCoupon';
  /** The coupon object as entered by the customer */
  coupon: CartCouponMetadata;
  /** Handles coupon validity */
  notices: Array<CartNotice>;
};

/** The code for a CartCoupon */
export type CartCouponMetadata = {
  __typename?: 'CartCouponMetadata';
  /** The coupon code as entered by the customer, e.g. 15CASHOFF */
  code: Scalars['String'];
};

/** Generic error type returned by Cart batch mutations */
export type CartItemError = Error & {
  __typename?: 'CartItemError';
  offerId: Scalars['ID'];
  message: Scalars['String'];
};

/** Response for mutations that only involve one item */
export type CartMutationResponse = Cart | UserError | UnauthorisedUserError;

/** A notice attached to a Cart, CartParcel or CartParcelItem */
export type CartNotice = {
  __typename?: 'CartNotice';
  /** Text details of the cart notice, eg: 'This offer has expired.' */
  message: TemplateString;
  /** Type of the notice, eg: 'ERROR', 'INFO' */
  type: CartNoticeType;
  /** If the notice is advisory, checkout can still occur (meaning the notice is non blocking) */
  advisory: Scalars['Boolean'];
};

/** CartNoticeType is used to determine the colour to display on the frontend and whether the notice blocks checkout */
export type CartNoticeType = 
  | 'ERROR'
  | 'WARNING'
  | 'INFO';

/**
 * A summary of the customer's order. Includes the cost of items, delivery charges and more.
 * Supports both web and iOS requirements.
 */
export type CartOrderSummary = {
  __typename?: 'CartOrderSummary';
  /** Identifier to assist data normalisation within Apollo cache */
  id: Scalars['ID'];
  /** Items displayed as costs to the customer */
  itemSummary: OrderSummaryItems;
  /** Cost and type of delivery */
  delivery?: Maybe<OrderSummaryDelivery>;
  /** Details of the current charity, customers can donate by rounding up to the nearest dollar. */
  donation?: Maybe<OrderSummaryDonation>;
  /** Show applied gift cards */
  giftCards: Array<OrderSummaryGiftCard>;
  /** Show applied discounts such as coupons or club catch free shipping */
  discounts: Array<OrderSummaryDiscount>;
  /** Store credit */
  storeCredit?: Maybe<StoreCreditSummary>;
  /**
   * Determines whether customer needs to verify their age for order submission.
   * This value is derived from the `ageRestricted` field.
   */
  ageConfirmationRequired?: Maybe<Scalars['Boolean']>;
  /** Subtotal derived from all items in each cart group */
  subtotalPrice: Money;
  /** Final total cost to the customer */
  totalPrice: Money;
  /** Total amount saved on RRP */
  totalSaving: Money;
};

/** A collection of items in a Cart to be shipped to the user from the same seller */
export type CartParcel = {
  __typename?: 'CartParcel';
  /** UUID of the grouping, determined by grouping metadata */
  id: Scalars['ID'];
  /** Name of the seller for the items in this parcel */
  sellerName: Scalars['String'];
  /** If this parcel is from a Marketplace seller */
  marketplaceSeller: Scalars['Boolean'];
  /** Line items within the group */
  items: Array<CartParcelItem>;
  /** Information about parcel dispatch such as dispatch type and expected date range */
  dispatchNotice?: Maybe<CartParcelDispatchNotice>;
  /** Shows delivery estimate labels on cart. */
  deliveryEstimate?: Maybe<DeliveryEstimate>;
  /** Selected shipping option */
  selectedShippingOption?: Maybe<CartParcelShippingOption>;
  /** List of shipping options on the cart group */
  shippingOptions: Array<CartParcelShippingOption>;
  /**
   * The total price of all the line items within the group
   * @deprecated Only for use by legacy iOS cart
   */
  subtotalPrice: Money;
  /**
   * Total amount of discounts provided by Club Catch, if applicable
   * @deprecated Only for use by legacy iOS cart
   */
  clubDiscountPrice: Money;
  /**
   * Informative message regarding Club Catch eligibility for this parcel
   * @deprecated Only for use by legacy iOS cart
   */
  clubDiscountMessage: Scalars['String'];
  /** Is this parcel eligible for a club membership up sell? */
  clubUpsellEligible: Scalars['Boolean'];
  /** Is this parcel shipping discounted due to the membership status? */
  isShippingMemberDiscounted: Scalars['Boolean'];
};

export type CartParcelDispatchNotice = {
  __typename?: 'CartParcelDispatchNotice';
  /** Handles notices to be shown inside delivery box if applicable, eg: 'Leaves warehouse in 1-2 business days' */
  message: Scalars['String'];
  type: CartParcelDispatchNoticeType;
};

export type CartParcelDispatchNoticeType = 
  | 'SPECIAL_ORDER'
  | 'IN_STOCK'
  | 'BULKY_SPECIAL_ORDER'
  | 'BULKY_IN_STOCK';

/** This represents a line item in the cart */
export type CartParcelItem = {
  __typename?: 'CartParcelItem';
  /** ID of the cart group item */
  id: Scalars['ID'];
  /** Offer associated with the item */
  offer: Offer;
  /** Link to the line item, eg: '/product/5965847?ofid=372618927' */
  uri: Scalars['String'];
  /** Selected quantity of the item */
  quantity: Scalars['Int'];
  /** This item has free shipping (not including Club free shipping - see offer.clubFreeShipping) */
  freeShipping: Scalars['Boolean'];
  /** This item is eligible for club catch auto express shipping upgrade */
  clubAutoExpressShipping: Scalars['Boolean'];
  /** Total displayed price for the item, inclusive of all quantities and tax */
  totalPrice: Money;
  /** Unit price for the item, inclusive of all discounts */
  unitPrice: Money;
  /** Whether the item was added by a coupon for free, for example free merchandise */
  addedByCoupon: Scalars['Boolean'];
  /** The title to be displayed on the line item */
  title: Scalars['String'];
  /** Personalised values of item */
  personalisedValues: Array<PersonalisedValue>;
  /** Metadata about the line item (eg: tracking */
  metadata: CartParcelItemMetadata;
  /** Informative messages or errors for the customer at the item level */
  notices: Array<CartNotice>;
};

/**
 * Source metadata fields for Snowplow tracking representing the origin of the item in the cart.
 * These get stored on the cartItem to denote if the product came from Wishlist or Search or Product grid etc and the
 * position on the grid and platform etc where it originated.
 */
export type CartParcelItemMetadata = {
  __typename?: 'CartParcelItemMetadata';
  /** The ID of a tracking source, could be an int or a string in the case of search terms */
  sourceId?: Maybe<Scalars['String']>;
  /** The position the item is in a product grid */
  sourcePosition?: Maybe<Scalars['Int']>;
  /** The type of source tracking. See CartItem in CotdWebsite for full list of type ids */
  sourceType?: Maybe<Scalars['Int']>;
  /** The platform id (an int) 1 = Web, 2 = Mobile Web etc. See CotdWebsite Platform entity */
  sourcePlatform?: Maybe<SourcePlatformType>;
  /** The ID of event this product is part of, when added to cart */
  eventId?: Maybe<Scalars['Int']>;
};

export type CartParcelShippingOption = {
  __typename?: 'CartParcelShippingOption';
  /** ID of the shipping option */
  id: Scalars['ID'];
  /** The type of the shipping option, eg: click & collect, normal */
  type: DeliveryType;
  /** The type of place where the item is being delivered to, e.g. parcel locker, click and collect */
  locationType: DeliveryLocationType;
  /** Title of the shipping option, eg: 'Standard', 'Express', 'Pick Up' */
  title: Scalars['String'];
  /**
   * Before price to be displayed as-is with strikethrough if applicable, eg: '$5.99'
   * @deprecated We're removing strike through pricing to make things simpler for our customers
   */
  retailPrice?: Maybe<Money>;
  /** Price total to be displayed as-is, eg: '$4.50', 'FREE' */
  price: Money;
  /** If this shipping option is free with Club Catch */
  clubFreeShipping: Scalars['Boolean'];
  /**
   * The amount to add to standard shipping to get the express price
   * @deprecated Only for use by legacy iOS cart
   */
  expressDifferencePrice?: Maybe<Money>;
  /** A small tag to be shown if applicable, eg: 'CHEAPEST' */
  attentionTag?: Maybe<Scalars['String']>;
  /** The click and collect options available for this parcel, e.g. target, kmart, kmart-cnc */
  availableCnCOptions: Array<ClickAndCollectOption>;
};

export type CartShippingLocation = {
  __typename?: 'CartShippingLocation';
  /** Name of the city, eg: 'Bentleigh East' */
  city?: Maybe<Scalars['String']>;
  /** State code, eg: 'VIC' */
  stateCode?: Maybe<Scalars['String']>;
  /** Postcode, eg: '3000' */
  postcode: Scalars['String'];
};

export type CartUpsellRecommendationInput = {
  productIds: Array<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttributes?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
};

export type CartUpsellResponse = {
  __typename?: 'CartUpsellResponse';
  /** Full product data to return */
  product?: Maybe<Product>;
  metaData: RecommenderMetaData;
};

/**
 * A customer category, which defines the grouping of items on the website, externally this is mapped to the seller categories and buyer categories.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type Category = {
  __typename?: 'Category';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "growth") */
  name: Scalars['String'];
  /** owner(tribe: "Digital", squad: "growth") */
  slug: Scalars['String'];
  /** owner(tribe: "Digital", squad: "growth") */
  level: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "growth") */
  parent?: Maybe<Category>;
  /**
   * Whether or not this is the final category in the hierarchy.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  leaf: Scalars['Boolean'];
};

export type CategoryByIdInput = {
  id: Scalars['ID'];
};

export type CategoryRecommendedProductsInput = {
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type CategoryRecommendedProductsResponse = {
  __typename?: 'CategoryRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
  categoryTitle: Scalars['String'];
};

/** Checkout information */
export type Checkout = {
  __typename?: 'Checkout';
  /** Identifier to assist data normalisation within Apollo cache */
  id: Scalars['ID'];
  /** Informative messages or errors for the customer at the cart level (displayed at top) */
  notices: Array<CheckoutNotice>;
  /** The customer checking out */
  customer?: Maybe<Customer>;
  /** The cart being checked out */
  cart: Cart;
  /** A list of available payment methods */
  paymentMethods: Array<PaymentMethod>;
  /** The selected payment method */
  selectedPaymentMethod?: Maybe<PaymentMethod>;
  /** Flags whether the cart is on a sales channel that supports gift card payments */
  giftCardSupported: Scalars['Boolean'];
  /** The ID of the chosen delivery address. Defaults to the default address. */
  selectedAddress?: Maybe<Address>;
  /** Determines single-item, buy-now express checkout flow */
  express?: Maybe<Scalars['Boolean']>;
};

export type CheckoutMutationResponse = Checkout | UserError;

/** A notice to display at the checkout */
export type CheckoutNotice = {
  __typename?: 'CheckoutNotice';
  /** Text details of the checkout notice */
  message: TemplateString;
  /** Type of the notice, eg: 'ERROR', 'INFO' */
  type: CheckoutNoticeType;
  /** If the notice is advisory, checkout can still occur (meaning the notice is non blocking) */
  advisory: Scalars['Boolean'];
};

/** CheckoutNoticeType is used to determine the colour to display on the frontend and whether the notice blocks checkout */
export type CheckoutNoticeType = 
  | 'ERROR'
  | 'WARNING'
  | 'INFO';

export type ChristmasDeliveryData = {
  __typename?: 'ChristmasDeliveryData';
  deliveryType: Scalars['String'];
  cncEligible: Scalars['Boolean'];
  requiresExpress: Scalars['Boolean'];
  postcode?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['ID']>;
  deliveryMessage: Scalars['String'];
  tooltip: Scalars['String'];
  showTooltip: Scalars['Boolean'];
  tracking: ChristmasDeliveryTracking;
};

export type ChristmasDeliveryInput = {
  offerId: Scalars['ID'];
  postcode: Scalars['String'];
};

export type ChristmasDeliveryResponse = ChristmasDeliveryData | UserError;

export type ChristmasDeliveryTracking = {
  __typename?: 'ChristmasDeliveryTracking';
  category: Scalars['String'];
  action: Scalars['String'];
  label: Scalars['String'];
  property: Scalars['String'];
};

export type ClickAndCollectOption = 
  | 'TARGET'
  | 'KMART'
  | 'KMART_CNC';

/**
 * Information about customer's ClubCatch membership
 * 
 * `owner(tribe: "Digital", squad: "loyalty")`
 */
export type ClubCustomerSubscription = ClubSubscription & {
  __typename?: 'ClubCustomerSubscription';
  /**
   * Whether current subscription is active
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  active: Scalars['Boolean'];
  /**
   * Whether user has been a Club Catch or Catch-OnePass member before
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  hasBeenClubCatchMember: Scalars['Boolean'];
  /**
   * Whether current subscription is under free trial period
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   * @deprecated use onFreeTrial
   */
  freeTrial: Scalars['Boolean'];
  /**
   * Whether current subscription is under free trial period
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  onFreeTrial: Scalars['Boolean'];
  /**
   * Number of active days remaining until current active period ends
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  activeDaysRemaining: Scalars['Int'];
  /**
   * Whether current subscription is auto renewing. False means it is cancelling.
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  autoRenewing: Scalars['Boolean'];
  /**
   * Current subscription interval
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  interval: ClubSubscriptionInterval;
  /**
   * The purchase price of current subscription
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  purchasePrice?: Maybe<Scalars['String']>;
  /**
   * The renewal price of current subscription
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  renewalPrice?: Maybe<Scalars['String']>;
  /**
   * The start date of the current subscription
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  latestMembershipPeriodStart?: Maybe<Scalars['DateTime']>;
  /**
   * The end date of the current subscription. a.k.a. expiry date or next billing date
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  latestMembershipPeriodEnd?: Maybe<Scalars['DateTime']>;
  /**
   * Whether the user is eligible for free trial
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  freeTrialEligible: Scalars['Boolean'];
  /**
   * Number of days remaining of free trial of current subscription
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  freeTrialDaysRemaining?: Maybe<Scalars['Int']>;
  /**
   * owner(tribe: "Digital", squad: "loyalty")
   * @deprecated use latestMembershipPeriodEnd
   */
  nextBillingDate: Scalars['DateTime'];
};

export type ClubSubscription = {
  /** Subscription interval */
  interval: ClubSubscriptionInterval;
  /** Subscription next billing date aka expiry date */
  nextBillingDate: Scalars['DateTime'];
};

export type ClubSubscriptionInterval = 
  | 'MONTHLY'
  | 'YEARLY';

export type CoPurchasedProducts = {
  __typename?: 'CoPurchasedProducts';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

export type CoPurchasedProductsInput = {
  productId: Scalars['ID'];
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  excludedProductIds?: Maybe<Array<Scalars['ID']>>;
  includeClubProducts?: Maybe<Scalars['Boolean']>;
};

export type ConditionCode = 
  | 'NEW'
  | 'REFURBISHED';

/** Namespace for configuration queries */
export type Configuration = {
  __typename?: 'Configuration';
  header: HeaderConfiguration;
};


/** Namespace for configuration queries */
export type ConfigurationHeaderArgs = {
  input?: Maybe<HeaderConfigurationInput>;
};

/**
 * Single coupon data
 * 
 * All fields except id, code, toDate, salesRule.shortDescription, longDescription are used for tracking purpose
 * 
 *     `owner(tribe: "Digital", squad: "conversion")`
 */
export type Coupon = {
  __typename?: 'Coupon';
  /** owner(tribe: "Digital", squad: "conversion") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "conversion") */
  code: Scalars['String'];
  /** owner(tribe: "Digital", squad: "conversion") */
  fromDate: Scalars['DateTime'];
  /** owner(tribe: "Digital", squad: "conversion") */
  toDate: Scalars['DateTime'];
  /** owner(tribe: "Digital", squad: "conversion") */
  usageLimit?: Maybe<Scalars['Int']>;
  /**
   * The number of times the coupon can be used by any given customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  usagePerCustomer?: Maybe<Scalars['Int']>;
  /**
   * Is coupon assigned to a specific list of customers
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  specificCustomers: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "conversion") */
  isActive: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "conversion") */
  promoActive: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "conversion") */
  version: Scalars['Float'];
  /**
   * used to sort coupon in the backend
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  ordinal: Scalars['Int'];
  /**
   * The number of times the coupon has been used
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  timesUsed: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "conversion") */
  salesRule: SalesRule;
};

export type CouponByCodeInput = {
  code: Scalars['String'];
};

export type CouponPayload = Coupon | UserError;

export type CouponsPayload = CustomerCoupons | UserError;

export type CreditCard = {
  __typename?: 'CreditCard';
  id: Scalars['ID'];
  brand: CreditCardBrand;
  /** Masked Credit Card number with last 4 digits unmasked */
  maskedCardNumber: Scalars['String'];
  expiryMonth: Scalars['Int'];
  expiryYear: Scalars['Int'];
};

export type CreditCardBrand = 
  | 'VISA'
  | 'MASTERCARD'
  | 'AMERICAN_EXPRESS';


/**
 * Represents information about a Catch customer
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type Customer = User & Node & {
  __typename?: 'Customer';
  /**
   * Customer UUID
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  id: Scalars['ID'];
  /**
   * First name of customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  firstName?: Maybe<Scalars['String']>;
  /**
   * Last name of customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  lastName?: Maybe<Scalars['String']>;
  /**
   * Email address of customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  email: Scalars['EmailAddress'];
  /**
   * Display name of customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  displayName?: Maybe<Scalars['String']>;
  /**
   * Address information of customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  addressBook?: Maybe<AddressBook>;
  /**
   * Membership details of customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  membership?: Maybe<Membership>;
  /**
   * Payment details of customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  paymentDetails?: Maybe<PaymentDetails>;
  /**
   * Metadata pertaining to the customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  metaData: CustomerMetaData;
  /**
   * Value of customers store credit
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  storeCredit: StoreCredit;
  /**
   * The notification badges for the customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  notificationBadges: Array<NotificationBadge>;
  /**
   * Saved credit cards associated with the customer
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  savedCards: Array<CreditCard>;
  /**
   * Information about customer's club Catch membership
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  club?: Maybe<ClubCustomerSubscription>;
};


/**
 * Represents information about a Catch customer
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type CustomerMembershipArgs = {
  input?: Maybe<MembershipInput>;
};

/**
 * All coupons related to a customer
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type CustomerCoupons = {
  __typename?: 'CustomerCoupons';
  /** owner(tribe: "Digital", squad: "conversion") */
  coupons: Array<Coupon>;
  /** owner(tribe: "Digital", squad: "conversion") */
  customerId: Scalars['ID'];
};

export type CustomerMetaData = {
  __typename?: 'CustomerMetaData';
  duuid: Scalars['String'];
  customerUuid?: Maybe<Scalars['String']>;
};



/** Delete customer input */
export type DeleteCustomerInput = {
  /** Reason for deleting customer */
  reason?: Maybe<Scalars['String']>;
};

export type DeleteCustomerResponse = BooleanResponse | UnauthorisedUserError | UserError;

export type DeliveryEstimate = {
  __typename?: 'DeliveryEstimate';
  /** Shows delivery estimate on parcel level. eg: Estimated standard delivery date: Aug 16 - 19 */
  label?: Maybe<Scalars['String']>;
  /** Shows whether Estimated | Fallback indicates the labels are estimated or fallback. */
  labelType?: Maybe<LabelType>;
  /** Description for delivery estimate label. */
  labelDescription?: Maybe<Scalars['String']>;
  /** Shows short label for delivery estimate which shows in delivery type for each parcel. eg: Estimated: Aug 16 - 19 */
  shortLabel?: Maybe<Scalars['String']>;
  /** The delivery date minimum range for estimate label. Using for tracking purposes. */
  minRange?: Maybe<Scalars['String']>;
  /** The delivery date maximum range for estimate label. Using for tracking purposes. */
  maxRange?: Maybe<Scalars['String']>;
  /** The timestamp at which the delivery estimate labels are generated. Using for tracking purposes. */
  timeStamp?: Maybe<Scalars['String']>;
  /** The confidence number is the accuracy of generated labels for delivery estimates. Using for tracking purposes. */
  confidence?: Maybe<Scalars['String']>;
};

export type DeliveryEstimateEntry = DeliveryEstimateSuccessEntry | DeliveryEstimateErrorEntry;

export type DeliveryEstimateError = Error & {
  __typename?: 'DeliveryEstimateError';
  offerId: Scalars['ID'];
  code: DeliveryEstimateErrorCode;
  message: Scalars['String'];
};

export type DeliveryEstimateErrorCode = 
  /** Generic failure code. */
  | 'ERROR'
  /** Generic info code. */
  | 'INFO';

/** Delivery estimate entry for a failed response. */
export type DeliveryEstimateErrorEntry = {
  __typename?: 'DeliveryEstimateErrorEntry';
  offerId: Scalars['ID'];
  error: DeliveryEstimateError;
};

/** Delivery estimate error response for a single offer. */
export type DeliveryEstimateOfferErrorResponse = {
  __typename?: 'DeliveryEstimateOfferErrorResponse';
  offerId: Scalars['ID'];
  postcode: Scalars['String'];
  error: DeliveryEstimateError;
};

/** Delivery estimate response for a single offer. */
export type DeliveryEstimateOfferResponse = DeliveryEstimateOfferSuccessResponse | DeliveryEstimateOfferErrorResponse;

/** Delivery estimate success response for a single offer. */
export type DeliveryEstimateOfferSuccessResponse = {
  __typename?: 'DeliveryEstimateOfferSuccessResponse';
  offerId: Scalars['ID'];
  postcode: Scalars['String'];
  /** The delivery estimate for the offer. */
  deliveryEstimate: DeliveryEstimate;
};

/** Delivery estimate response for a product; contains multiple offers. */
export type DeliveryEstimateProductResponse = {
  __typename?: 'DeliveryEstimateProductResponse';
  productId: Scalars['ID'];
  postcode: Scalars['String'];
  /** The delivery estimates response for the product. */
  deliveryEstimates: Array<DeliveryEstimateEntry>;
};

/** Delivery estimate entry for a successful response. */
export type DeliveryEstimateSuccessEntry = {
  __typename?: 'DeliveryEstimateSuccessEntry';
  offerId: Scalars['ID'];
  deliveryEstimate?: Maybe<DeliveryEstimate>;
};

export type DeliveryLocationType = 
  | 'NORMAL'
  | 'PARCEL_LOCKER'
  | 'CLICK_AND_COLLECT';

export type DeliveryType = 
  | 'STANDARD'
  | 'EXPRESS'
  | 'PICKUP';


/** Interface that can be implemented for user facing error types */
export type Error = {
  message: Scalars['String'];
};

export type EssentialsMenu = {
  __typename?: 'EssentialsMenu';
  giftCards?: Maybe<Scalars['String']>;
  catchMobile: Scalars['String'];
};

/**
 * Events are a type of customer facing entity that can be scheduled and typically have a collection of Products associated with them.
 * Events also contain information such as title, subtitle, as well other generic high level data use to describe itself.
 * 
 *     `owner(tribe: "Digital", squad: "growth")`
 */
export type Event = {
  __typename?: 'Event';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /**
   * The title of the Event.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  title: Scalars['String'];
  /**
   * The URL pointing to the Event view.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  url: Scalars['String'];
  /**
   * Event slug.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  slug: Scalars['String'];
  /**
   * Event banner image in different sizes.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  image: EventImage;
  /**
   * The badge text of the Event, which contains additional information pertaining to the Event.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  badgeText?: Maybe<Scalars['String']>;
  /**
   * The product count of the Event.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  productCount: Scalars['Int'];
  /**
   * The sellable product count of the Event.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  sellableProductCount: Scalars['Int'];
  /**
   * This field is to be populated when an Event only has one product associated with it.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  product?: Maybe<Product>;
  /**
   * Additional text for extra information/flavor
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  pillText?: Maybe<Scalars['String']>;
  /**
   * Title for OnePass related display (e.g. hero deals)
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  onePassTitle?: Maybe<Scalars['String']>;
  /**
   * Subtext for OnePass related display (e.g. hero deals)
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  onePassSubtext?: Maybe<Scalars['String']>;
};

export type EventBySlugInput = {
  slug: Scalars['String'];
};

export type EventBySlugResponse = {
  __typename?: 'EventBySlugResponse';
  event?: Maybe<Event>;
};

export type EventImage = {
  __typename?: 'EventImage';
  single: Image;
  wide?: Maybe<Image>;
  onePassPrePromote?: Maybe<Image>;
};

export type ExistingCustomer = {
  __typename?: 'ExistingCustomer';
  exists: Scalars['Boolean'];
};

export type ExistingCustomerInput = {
  email: Scalars['EmailAddress'];
};

export type ExistingCustomerResponse = ExistingCustomer | UserError;

export type Experiment = {
  __typename?: 'Experiment';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['ID']>;
  experiment: Scalars['String'];
  bucket: Scalars['Int'];
  variation: Scalars['String'];
  active: Scalars['Boolean'];
};

export type ExperimentsInput = {
  experiments: Array<Scalars['String']>;
};

export type ExperimentsPayload = {
  __typename?: 'ExperimentsPayload';
  experiments: Array<Experiment>;
  ccx?: Maybe<Scalars['String']>;
};

export type FeaturedProductsByEventIdInput = {
  eventId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
};

export type FeaturedProductsByEventIdResponse = {
  __typename?: 'FeaturedProductsByEventIdResponse';
  products: Array<Product>;
};

export type FomoProductRecommendationsInput = {
  excludedProductIds?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
};

export type FomoProductRecommendationsResponse = {
  __typename?: 'FomoProductRecommendationsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

/** Data to display the footer on Catch.com.au */
export type Footer = {
  __typename?: 'Footer';
  /** Page links displayed in the footer */
  navigationLinkColumns: Array<NavigationLinkColumn>;
  /** Copyright and disclaimer information for the footer (HTML) */
  copyright: Scalars['String'];
  /** App download links */
  appDownloadLinks: Array<AppDownloadLink>;
};

export type FrequentlyBoughtTogetherInput = {
  productIds: Array<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type FrequentlyBoughtTogetherResponse = {
  __typename?: 'FrequentlyBoughtTogetherResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

/** Configuration used to connect to GTM */
export type GtmConfiguration = AnalyticVendorConfiguration & {
  __typename?: 'GTMConfiguration';
  enabled: Scalars['Boolean'];
  containerId: Scalars['String'];
};

/**
 * Schema for geolocation data i.e. latitude and longitude
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type Geolocation = {
  __typename?: 'Geolocation';
  /** owner(tribe: "Digital", squad: "conversion") */
  latitude?: Maybe<Scalars['Float']>;
  /** owner(tribe: "Digital", squad: "conversion") */
  longitude?: Maybe<Scalars['Float']>;
};

/** Configuration used to render the Catch.com.au header */
export type HeaderConfiguration = {
  __typename?: 'HeaderConfiguration';
  meta: HeaderMetaConfiguration;
  topHeader: TopHeaderConfiguration;
  primaryHeader: PrimaryHeaderConfiguration;
  headerTheme?: Maybe<HeaderTheme>;
  megaMenu: MegaMenuConfiguration;
};

/** Optional input for header configuration */
export type HeaderConfigurationInput = {
  domain: Scalars['String'];
};

/** Header Meta Data */
export type HeaderMetaConfiguration = {
  __typename?: 'HeaderMetaConfiguration';
  salesChannel: HeaderMetaSalesChannelConfiguration;
};

/** Header sales channel configuration */
export type HeaderMetaSalesChannelConfiguration = {
  __typename?: 'HeaderMetaSalesChannelConfiguration';
  code: Scalars['String'];
};

export type HeaderTheme = 
  | 'christmas';

export type HelpfulReview = {
  __typename?: 'HelpfulReview';
  positiveCount: Scalars['Int'];
  negativeCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  /** The logged in customer feedback for this review (1 = helpful, -1 = not helpful, 0 = no feedback, null = not logged in) */
  customerHelpfulFeedback?: Maybe<Scalars['Int']>;
};

export type HelpfulReviewMutationResponse = ProductReview | UserError | UnauthorisedUserError;

/** An image type MediaAsset */
export type Image = MediaAsset & {
  __typename?: 'Image';
  id: Scalars['ID'];
  /** The id can be 'placeholder' when no image is found and the placeholder is returned */
  url: Scalars['URL'];
  altText: Scalars['String'];
  /** The height of the image in pixels */
  height: Scalars['Int'];
  /** The width of the image in pixels */
  width: Scalars['Int'];
};

export type IncompatibleItemsAction = 
  | 'RERANK'
  | 'REMOVE';



export type KasadaConfiguration = {
  __typename?: 'KasadaConfiguration';
  scriptUrl?: Maybe<Scalars['String']>;
  protectedEndpoints: Array<Maybe<KasadaProtectedEndpoints>>;
};

export type KasadaConfigurationInput = {
  domain: Scalars['String'];
};

export type KasadaProtectedEndpoints = {
  __typename?: 'KasadaProtectedEndpoints';
  method: Scalars['String'];
  path: Scalars['String'];
  domain: Scalars['String'];
};

export type LabelType = 
  | 'Estimated'
  | 'Fallback';

export type LatestEventsInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  includeAdultEvents?: Maybe<Scalars['Boolean']>;
};

export type LatestEventsResponse = {
  __typename?: 'LatestEventsResponse';
  events: Array<Event>;
};

/**
 * A summary of the customer's order. This does not include any gift card use and donation round up
 * Only use in iOS.
 */
export type LegacyCartOrderSummary = {
  __typename?: 'LegacyCartOrderSummary';
  discounts: Array<LegacyOrderSummaryDiscount>;
  /** Shipping cost */
  shippingPrice?: Maybe<Money>;
  /** Store credit applied */
  storeCreditApplied?: Maybe<Money>;
  /** Subtotal derived from all items in each cart group */
  subtotalPrice: Money;
  /** Final total cost to the customer, exclude gift card and donation round up */
  totalPrice: Money;
};

export type LegacyOrderSummaryDiscount = {
  __typename?: 'LegacyOrderSummaryDiscount';
  discount: Money;
  name: Scalars['String'];
};

export type LiveBannersInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  includeAdultBanners?: Maybe<Scalars['Boolean']>;
};

export type LiveBannersResponse = {
  __typename?: 'LiveBannersResponse';
  banners: Array<Banner>;
};

export type LiveEventsInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  includeAdultEvents?: Maybe<Scalars['Boolean']>;
};

export type LiveEventsResponse = {
  __typename?: 'LiveEventsResponse';
  events: Array<Event>;
};

/**
 * Location data
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type Location = {
  __typename?: 'Location';
  /** owner(tribe: "Digital", squad: "conversion") */
  id: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "conversion") */
  postcode: Scalars['String'];
  /** owner(tribe: "Digital", squad: "conversion") */
  suburb: Scalars['String'];
  /** owner(tribe: "Digital", squad: "conversion") */
  state?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "conversion") */
  stateCode?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "conversion") */
  country?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "conversion") */
  geolocation?: Maybe<Geolocation>;
};

/** location result schema with geolocation info */
export type LocationResult = {
  __typename?: 'LocationResult';
  id: Scalars['Int'];
  postcode: Scalars['String'];
  suburb: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  geolocation: Geolocation;
};

/**
 * Input for postcode suggestions query
 * 
 * If no input is provided, all postcodes in the current user's country will be returned
 * 
 *     `owner(tribe: "Digital", squad: "conversion")`
 */
export type LocationSuggestionsInput = {
  postcode?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  searchParameters?: Maybe<LocationSuggestionsSearchParameters>;
};

/** owner(tribe: "Digital", squad: "conversion") */
export type LocationSuggestionsResult = {
  __typename?: 'LocationSuggestionsResult';
  /** owner(tribe: "Digital", squad: "conversion") */
  postcodes: Array<Location>;
};

/**
 * Search parameters for postcode suggestions
 * 
 * searchTerm can be either a postcode or a suburb name
 * filterByGeolocation filters out postcodes that do not have any geolocation data
 * 
 *     `owner(tribe: "Digital", squad: "conversion")`
 */
export type LocationSuggestionsSearchParameters = {
  searchTerm?: Maybe<Scalars['String']>;
  maxResults?: Maybe<Scalars['Int']>;
  filterByGeolocation?: Maybe<Scalars['Boolean']>;
};

/** Mark a review helpful */
export type MarkReviewHelpfulInput = {
  reviewId: Scalars['ID'];
  /** helpfulCountAdjustment can be 1 (helpful), -1 (unhelpful) or 0 (cancelled) */
  helpfulCountAdjustment: Scalars['Int'];
};

/** A reference to a media asset via a URL (images, videos, etc.) */
export type MediaAsset = {
  id: Scalars['ID'];
  /** The address of the asset */
  url: Scalars['URL'];
  /** The alt text of the asset */
  altText: Scalars['String'];
};

/** Mega menu configuration */
export type MegaMenuConfiguration = {
  __typename?: 'MegaMenuConfiguration';
  enabled: Scalars['Boolean'];
  navData: MegaMenuData;
};

export type MegaMenuData = {
  __typename?: 'MegaMenuData';
  shops: Array<Shop>;
  catchEssentialsMenu?: Maybe<EssentialsMenu>;
  accountMenu: AccountMenu;
};

/**
 * Membership details of a customer
 * 
 * `owner(tribe: "CAL", squad: "LS")`
 */
export type Membership = {
  __typename?: 'Membership';
  /** owner(tribe: "CAL", squad: "LS") */
  id?: Maybe<Scalars['ID']>;
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.linked
   */
  onePassLinked: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.active
   */
  hasActiveOnePassSubscription: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.freeTrialEligible
   */
  eligibleFreeTrial: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.onFreeTrial
   */
  isFreeTrial: Scalars['Boolean'];
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.freeTrialDaysRemaining
   */
  freeTrialDaysRemaining?: Maybe<Scalars['Int']>;
  /** owner(tribe: "CAL", squad: "LS") */
  linked: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  eligibleForUpsell: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  eligibleForMigration: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  doubleSubscription: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  subscription?: Maybe<MembershipSubscriptionDetails>;
  /** owner(tribe: "CAL", squad: "LS") */
  benefits?: Maybe<MembershipBenefits>;
  /**
   * owner(tribe: "CAL", squad: "LS")
   * @deprecated use membership.subscription.isTeamMember
   */
  isTeamMember: Scalars['Boolean'];
};

/** Membership benefits */
export type MembershipBenefits = {
  __typename?: 'MembershipBenefits';
  freeDelivery: Scalars['Boolean'];
  exclusiveOffers: Scalars['Boolean'];
  memberDiscounts: Scalars['Boolean'];
  extraPoints: Scalars['Boolean'];
};

export type MembershipInput = {
  /** Flag to force refresh customer's membership data */
  refresh?: Maybe<Scalars['Boolean']>;
};

/** Membership Subscription details */
export type MembershipSubscriptionDetails = {
  __typename?: 'MembershipSubscriptionDetails';
  active: Scalars['Boolean'];
  onFreeTrial: Scalars['Boolean'];
  activeDaysRemaining: Scalars['Int'];
  autoRenewing: Scalars['Boolean'];
  interval?: Maybe<Scalars['String']>;
  latestMembershipPeriodStart?: Maybe<Scalars['DateTime']>;
  latestMembershipPeriodEnd?: Maybe<Scalars['DateTime']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  renewalPrice?: Maybe<Scalars['Int']>;
  monthlyPrice: Scalars['Int'];
  yearlyPrice: Scalars['Int'];
  freeTrialDaysRemaining?: Maybe<Scalars['Int']>;
  freeTrialEligible: Scalars['Boolean'];
  isTeamMember: Scalars['Boolean'];
};

/** Represent a meta URL format */
export type MetaUrl = {
  __typename?: 'MetaURL';
  url: Scalars['URL'];
  media?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

/** Meta URL for a page */
export type MetaUrLs = {
  __typename?: 'MetaURLs';
  canonical: MetaUrl;
  alternate: Array<MetaUrl>;
};

export type ModelType = 
  | 'DESCRIPTION'
  | 'IMAGE'
  | 'IMAGE_AND_DESCRIPTION'
  | 'IMAGE_AND_CATEGORY';

/** Money object to handle currency */
export type Money = {
  __typename?: 'Money';
  /** monetary value in lowest divisible unit for currency (eg. cents for AUD) */
  amount: Scalars['Int'];
  /** currency value such as AUD */
  currency: Scalars['Currency'];
};

/** Move item to wishlist */
export type MoveItemFromCartToWishlistInput = {
  id: Scalars['ID'];
};

/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** owner(tribe: "Digital", squad: "conversion") */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Fetch an updated cart
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  updateBuyNowCart: UpdateBuyNowCartResponse;
  /**
   * Submit the cart for purchase
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  submitBuyNowCart: SubmitBuyNowCartResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  addItemsToCart: CartBatchMutationResponse;
  /** owner(tribe: "Digital", squad: "mobile") */
  addOrderToCart: BuyAgainMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  addToCart: CartMutationResponse;
  /**
   * Add or remove a donation on the users cart
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  toggleDonation: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  moveItemFromCartToWishlist: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  redeemGiftCard: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  removeCart: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "conversion") */
  removeCouponFromCart: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  removeGiftCardFromCart: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  removeItemFromCart: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  updateCartItemQuantity: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  updateCartLocation: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  updateCartProductOption: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  updateCartShippingOption: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  updateCartCoupon: CartMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  selectAddress: CheckoutMutationResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  addAddress: AddAddressResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  deleteCustomer: DeleteCustomerResponse;
  /** owner(tribe: "Digital", squad: "conversion") */
  removeSavedCard: RemoveSavedCardResponse;
  /**
   * Update user location
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  updateUserLocation: UpdateUserLocationResponse;
  /** owner(tribe: "Digital", squad: "growth") */
  markReviewHelpful: HelpfulReviewMutationResponse;
  /** owner(tribe: "Digital", squad: "growth") */
  addItemToWishlist: WishlistItemMutationResponse;
  /** owner(tribe: "Digital", squad: "growth") */
  removeItemFromWishlist: RemoveItemFromWishlistMutationResponse;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationUpdateBuyNowCartArgs = {
  input: UpdateBuyNowCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationSubmitBuyNowCartArgs = {
  input: UpdateBuyNowCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationAddItemsToCartArgs = {
  input: AddItemsToCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationAddOrderToCartArgs = {
  input: AddOrderToCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationAddToCartArgs = {
  input: AddToCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationToggleDonationArgs = {
  input: ToggleDonationInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationMoveItemFromCartToWishlistArgs = {
  input: MoveItemFromCartToWishlistInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationRedeemGiftCardArgs = {
  input: RedeemGiftCardInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationRemoveGiftCardFromCartArgs = {
  input: RemoveGiftCardFromCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationRemoveItemFromCartArgs = {
  input: RemoveItemFromCartInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationUpdateCartItemQuantityArgs = {
  input: UpdateCartItemQuantityInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationUpdateCartLocationArgs = {
  input: UpdateCartLocationInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationUpdateCartProductOptionArgs = {
  input: UpdateCartProductOptionInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationUpdateCartShippingOptionArgs = {
  input: UpdateCartShippingOptionInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationUpdateCartCouponArgs = {
  input: UpdateCartCouponInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationSelectAddressArgs = {
  input: SelectAddressInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationAddAddressArgs = {
  input: AddAddressInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationRemoveSavedCardArgs = {
  input: RemoveSavedCardInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationUpdateUserLocationArgs = {
  input: UpdateUserLocationInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationMarkReviewHelpfulArgs = {
  input: MarkReviewHelpfulInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationAddItemToWishlistArgs = {
  input: AddItemToWishlistInput;
};


/**
 * Mutation root type
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type MutationRemoveItemFromWishlistArgs = {
  input: RemoveItemFromWishlistInput;
};

/** owner(tribe: "Digital", squad: "conversion") */
export type MyAccountMenu = {
  __typename?: 'MyAccountMenu';
  /** owner(tribe: "Digital", squad: "conversion") */
  menuItems: Array<MyAccountMenuItem>;
};

export type MyAccountMenuItem = {
  __typename?: 'MyAccountMenuItem';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  id: Scalars['Int'];
  slug: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

/** A link within the footers column display */
export type NavigationLink = {
  __typename?: 'NavigationLink';
  /** The text content of the link (eg: Privacy Policy) */
  text: Scalars['String'];
  /** URL of the link */
  url: Scalars['String'];
  /** If true, link should spawn in a new window as opposed to the current window */
  openInNewWindow: Scalars['Boolean'];
  /** If true, a new space or tag for the bright edge implementation will be added */
  isBrightEdgeAutoPilotEnabled: Scalars['Boolean'];
};

/** A column of links in the footer */
export type NavigationLinkColumn = {
  __typename?: 'NavigationLinkColumn';
  /** Title text of the column (eg: Legal) */
  columnTitle: Scalars['String'];
  /** List of links within the column */
  links: Array<NavigationLink>;
};

/** An object with an ID to support global identification. */
export type Node = {
  /** Globally unique identifier. */
  id: Scalars['ID'];
};

export type NotificationBadge = {
  __typename?: 'NotificationBadge';
  menuItemId: Scalars['ID'];
  label: Scalars['String'];
};

/**
 * An offer to sell a variant of a product, the person making the offer may be catch or a marketplace seller. Each variant can have multiple offers, each of which will contain a condition, quantity and price they are offering to sell the product for. The price of an offer will alter and change depending on the promotions applied.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type Offer = {
  __typename?: 'Offer';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /**
   * Which sales channel the offer is for, should match the header value.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  salesChannel: SalesChannel;
  /** owner(tribe: "Digital", squad: "growth") */
  seller: Seller;
  /**
   * The price this seller is currently offering to sell the variant for.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  sellPrice: Money;
  /**
   * Information on how the price tag should be displayed
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  priceTag?: Maybe<PriceTag>;
  /**
   * The price this seller was originally offering to sell the variant for, prior to application of any promotions.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  originPrice?: Maybe<Money>;
  /**
   * The RRP price for this variant.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  retailPrice?: Maybe<Money>;
  /**
   * The current price that the seller is offering to sell to club member for.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  clubSellPrice?: Maybe<Money>;
  /**
   * Any disclaimer information regarding the retail price used.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   * @deprecated use `priceTag.retailPriceDisclaimer`
   */
  retailPriceDisclaimer?: Maybe<ProductRetailPriceDisclaimer>;
  /**
   * This field will return a indicative (to a fairly high level of reliability) state of stock.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  stockLevel: StockLevel;
  /**
   * The maximum quantity that can be added to cart for this offer.
   * It is calculated by the lowest value of the purchase limit and an estimated available stock amount (restricted to a realistic upper bound).
   * Typically used to set an upper bound on a quantity selector, given the very high latency on inventory updates, this value is not reliable on trending items.
   * 
   *     `owner(tribe: "Digital", squad: "growth")`
   */
  purchasableQuantity: Scalars['Int'];
  /**
   * The maximum amount of items a person can purchase for the offer at one time (per sale).
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  purchaseLimit?: Maybe<Scalars['Int']>;
  /**
   * Whether this item is available for click and collect
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  clickAndCollect: Scalars['Boolean'];
  /**
   * Whether the offer is eligible for free shipping for club members.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  clubFreeShipping: Scalars['Boolean'];
  /**
   * Whether this item can only be bought by Club members.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  clubExclusive: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "growth") */
  variant: Variant;
  /**
   * The currency code for an offer.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  currency: Scalars['Currency'];
  /**
   * Whether this offer has free shipping.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  freeShipping: Scalars['Boolean'];
  /**
   * The best before date for an offer.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  bestBefore?: Maybe<Scalars['DateTime']>;
  /**
   * The expiry date for an offer.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /**
   * The list of badges for an offer.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  badges: Array<Scalars['String']>;
  /**
   * The redeem by date for an offer.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  redeemBy?: Maybe<Scalars['DateTime']>;
  /**
   * The promotion end date for an offer
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  promotionEndDate?: Maybe<Scalars['DateTime']>;
  /**
   * Whether the offer is a catch promotion
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  catchPromotion: Scalars['Boolean'];
  /**
   * Warranty information
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  warranty?: Maybe<ProductWarranty>;
  /**
   * Delivery information
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  shipping?: Maybe<Shipping>;
  /**
   * Payment options that can be used to purchase this offer
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  paymentMethods: Array<PaymentType>;
  /**
   * The condition of the Product, eg New or Refurbished
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  conditionCode?: Maybe<ConditionCode>;
};

/** Namespace for frontend onepass configuration */
export type OnePassConfiguration = {
  __typename?: 'OnePassConfiguration';
  trialLength?: Maybe<Scalars['Int']>;
  priceMonthly?: Maybe<Money>;
  priceYearly?: Maybe<Money>;
  hotlineNo?: Maybe<Scalars['String']>;
};

export type OnePassRecommendedProductsInput = {
  limit?: Maybe<Scalars['Int']>;
};

export type OnePassRecommendedProductsResponse = {
  __typename?: 'OnePassRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
};

export type OnePassScheduleEntryInput = {
  /** Limits how many entries should be returned */
  limit?: Maybe<Scalars['Int']>;
  /** Acts as the pagination for the entries based on the 'limit' */
  page?: Maybe<Scalars['Int']>;
  /** Filters the entries based on the category, uncategorized if undefined */
  categoryId?: Maybe<Scalars['ID']>;
  /** Tiles/columns per entries row */
  tilesPerRow?: Maybe<Scalars['Int']>;
};

export type OrderSummaryDelivery = {
  __typename?: 'OrderSummaryDelivery';
  total: Money;
  deliveryType: DeliveryType;
};

export type OrderSummaryDiscount = {
  __typename?: 'OrderSummaryDiscount';
  discount: Money;
  label: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  deletable: Scalars['Boolean'];
  type: OrderSummaryDiscountType;
};

export type OrderSummaryDiscountType = 
  | 'MANUAL'
  | 'AUTOMATIC'
  | 'CLUB_FREE_SHIPPING';

export type OrderSummaryDonation = {
  __typename?: 'OrderSummaryDonation';
  /** The amount of donation */
  total: Money;
  organisationName: Scalars['String'];
  image: Image;
  body: Scalars['String'];
  header: Scalars['String'];
  /** The order price before the donation */
  orderTotalBefore: Money;
  /** The order price after the donation */
  orderTotalAfter: Money;
  /** Customer agreed to donate or not */
  selected: Scalars['Boolean'];
};

export type OrderSummaryGiftCard = {
  __typename?: 'OrderSummaryGiftCard';
  code: Scalars['String'];
  isOnePassReward: Scalars['Boolean'];
  appliedBalance: Money;
  remainingBalance: Money;
};

export type OrderSummaryItems = {
  __typename?: 'OrderSummaryItems';
  total: Money;
  items: Array<CartParcelItem>;
};

/** Namespace for frontend page configuration */
export type PageConfiguration = {
  __typename?: 'PageConfiguration';
  itunesAppUrl?: Maybe<Scalars['String']>;
  footerItunesAppUrl?: Maybe<Scalars['String']>;
  homeUspItunesAppUrl?: Maybe<Scalars['String']>;
  googlePlayUrl?: Maybe<Scalars['String']>;
  footerGooglePlayUrl?: Maybe<Scalars['String']>;
  homeUspGooglePlayUrl?: Maybe<Scalars['String']>;
};

/** Information about a cursor pagination result set */
export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

/** Customer Payment Details */
export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** Customer's default payment method */
  defaultPaymentMethodId: Scalars['ID'];
  availablePaymentMethods: Array<PaymentMethod>;
};

export type PaymentIcon = 
  | 'CREDIT_CARD_VISA'
  | 'CREDIT_CARD_MASTERCARD'
  | 'CREDIT_CARD_AMEX'
  | 'PAYPAL'
  /**
   * APPLE_PAY -- Missing icon in frontend
   * GOOGLE_PAY -- Missing icon in frontend
   */
  | 'ZIPPAY'
  | 'AFTERPAY'
  | 'LATITUDEPAY';

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** Type of payment method */
  paymentMethodId: Scalars['ID'];
  /** Description of the payment method to display */
  description: Scalars['String'];
  /** Denotes the payment icon to display (if available) */
  iconName?: Maybe<PaymentIcon>;
  /** Order index of payment method */
  ordinal: Scalars['Int'];
};

export type PaymentType = 
  | 'CREDIT_CARD'
  | 'PAYPAL'
  | 'APPLE_PAY'
  | 'GOOGLE_PAY'
  | 'ZIPPAY'
  | 'AFTERPAY'
  | 'LATITUDEPAY';

export type PeopleAlsoViewedInput = {
  productIds: Array<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  incompatibleItemsAction?: Maybe<IncompatibleItemsAction>;
};

export type PeopleAlsoViewedResponse = {
  __typename?: 'PeopleAlsoViewedResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

export type PersonalisedAttributes = {
  required: Scalars['Boolean'];
};

export type PersonalisedElementAttributes = PersonalisedTextAttributes | PersonalisedNumberAttributes | PersonalisedEmailAttributes | PersonalisedSelectAttributes;

export type PersonalisedElementType = 
  | 'TEXT'
  | 'TEXTAREA'
  | 'NUMBER'
  | 'EMAIL'
  | 'SELECT';

export type PersonalisedEmailAttributes = PersonalisedAttributes & {
  __typename?: 'PersonalisedEmailAttributes';
  required: Scalars['Boolean'];
};

export type PersonalisedEventsInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  includeAdultEvents?: Maybe<Scalars['Boolean']>;
};

export type PersonalisedEventsResponse = {
  __typename?: 'PersonalisedEventsResponse';
  events: Array<Event>;
  /** recommendations IDs, required for tracking */
  recommendedEventIds?: Maybe<Array<Scalars['Int']>>;
  metaData: RecommenderMetaData;
};

export type PersonalisedField = {
  __typename?: 'PersonalisedField';
  id: Scalars['ID'];
  name: Scalars['String'];
  label: Scalars['String'];
  elementType: PersonalisedElementType;
  attributes: PersonalisedElementAttributes;
};

export type PersonalisedNumberAttributes = PersonalisedAttributes & {
  __typename?: 'PersonalisedNumberAttributes';
  required: Scalars['Boolean'];
  min?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
};

export type PersonalisedOptionAttributes = {
  __typename?: 'PersonalisedOptionAttributes';
  name: Scalars['String'];
  label: Scalars['String'];
};

export type PersonalisedRecommendedProductsInput = {
  sellerId?: Maybe<Scalars['Int']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyOnePassEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  /** Descendingly order by product creation date */
  orderByProductCreationDateDesc?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PersonalisedRecommendedProductsResponse = {
  __typename?: 'PersonalisedRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

export type PersonalisedSelectAttributes = PersonalisedAttributes & {
  __typename?: 'PersonalisedSelectAttributes';
  required: Scalars['Boolean'];
  optionAttributes: Array<PersonalisedOptionAttributes>;
};

export type PersonalisedTextAttributes = PersonalisedAttributes & {
  __typename?: 'PersonalisedTextAttributes';
  required: Scalars['Boolean'];
  minlength?: Maybe<Scalars['Int']>;
  maxlength?: Maybe<Scalars['Int']>;
};

/** The customised key-value pair for a personalised product */
export type PersonalisedValue = {
  __typename?: 'PersonalisedValue';
  /** The field name to display in the frontend eg: 'Receiver's FirstName' */
  label: Scalars['String'];
  /** The customised value provided by the customer eg: 'Joe' */
  value: Scalars['String'];
};

/** Values for a personalised product */
export type PersonalisedValueInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Platform = 
  | 'DESKTOP'
  | 'MOBILE'
  | 'IPAD'
  | 'IPHONE'
  | 'ANDROID';

export type PopularEventsInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  includeAdultEvents?: Maybe<Scalars['Boolean']>;
};

export type PopularEventsResponse = {
  __typename?: 'PopularEventsResponse';
  events: Array<Event>;
};

export type PopularLink = {
  __typename?: 'PopularLink';
  text: Scalars['String'];
  url: Scalars['String'];
};

/**
 * Popular search links that are populated from the seo-pages-app
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type PopularSearches = {
  __typename?: 'PopularSearches';
  /** owner(tribe: "Digital", squad: "growth") */
  links: Array<PopularLink>;
};

export type PopularSearchesInput = {
  slug: Scalars['String'];
};


export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  /** Discount text to be displayed above the price tag. eg. 'Price Drop'. */
  label: Scalars['String'];
  /** Percentage discount displayed with discount text. eg. '35% Off'. */
  percentageLabel?: Maybe<Scalars['String']>;
  /** The end date for a price discount. Can be used for countdown timer. */
  endDate?: Maybe<Scalars['DateTime']>;
};

export type PriceLabel = {
  __typename?: 'PriceLabel';
  /** The was price displayed on the left of the price tag. */
  wasPrice?: Maybe<Money>;
  /** The selling price displayed in the middle of the price tag. */
  price: Money;
  /** Information to display the saving on the right of the price tag */
  saving?: Maybe<PriceLabelSaving>;
};

export type PriceLabelSaving = {
  __typename?: 'PriceLabelSaving';
  /** The savings label. eg. 'Save'. */
  label: Scalars['String'];
  /** The savings price. */
  savingAmount: Money;
};

/** owner(tribe: "Digital", squad: "growth") */
export type PriceTag = {
  __typename?: 'PriceTag';
  /**
   * Information to display the discount above tag.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  priceDiscount?: Maybe<PriceDiscount>;
  /**
   * Text to appear above the price tag. eg 'From' or 'Don't pay $9.99'.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  topLabel?: Maybe<Scalars['String']>;
  /**
   * Information to display the main price label.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  priceLabel: PriceLabel;
  /**
   * The club exlusive price. Will be displayed below price tag.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  clubSellPrice?: Maybe<Money>;
  /**
   * Flag that will determine if this is a club price tag.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  clubExclusive: Scalars['Boolean'];
  /**
   * Flag that will determine if the tag is enabled or greyed out.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  enabled: Scalars['Boolean'];
  /**
   * Any disclaimer information regarding the retail price used.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  retailPriceDisclaimer?: Maybe<ProductRetailPriceDisclaimer>;
};

/** Primary header account configuration */
export type PrimaryHeaderAccountFlag = {
  __typename?: 'PrimaryHeaderAccountFlag';
  enabled: Scalars['Boolean'];
  showFlybuysLink: Scalars['Boolean'];
};

/**
 * Primary header club configuration
 * 
 * `owner(tribe: "CAL", squad: "LS")`
 */
export type PrimaryHeaderClubFlag = {
  __typename?: 'PrimaryHeaderClubFlag';
  /** owner(tribe: "CAL", squad: "LS") */
  enabled: Scalars['Boolean'];
  /** owner(tribe: "CAL", squad: "LS") */
  clubCatchTileEnabled: Scalars['Boolean'];
};

/** Configuration for the main section of the header */
export type PrimaryHeaderConfiguration = {
  __typename?: 'PrimaryHeaderConfiguration';
  logo: PrimaryHeaderLogoFlag;
  searchBar: PrimaryHeaderFlag;
  club: PrimaryHeaderClubFlag;
  clubFlybuys: PrimaryHeaderFlag;
  flybuys: PrimaryHeaderFlag;
  cart: PrimaryHeaderFlag;
  wishlist: PrimaryHeaderFlag;
  myAccount: PrimaryHeaderAccountFlag;
};

/** Primary header flat configuration */
export type PrimaryHeaderFlag = {
  __typename?: 'PrimaryHeaderFlag';
  enabled: Scalars['Boolean'];
};

/** Logo Configuration */
export type PrimaryHeaderLogoFlag = {
  __typename?: 'PrimaryHeaderLogoFlag';
  enabled: Scalars['Boolean'];
  imageSrc: Scalars['String'];
  condensedImageSrc?: Maybe<Scalars['String']>;
  alt: Scalars['String'];
  url: Scalars['String'];
};

/**
 * A customer-facing item or service that can be sold. Products contain information such as title, description, as well other generic high level data use to describe itself.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type Product = {
  __typename?: 'Product';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /**
   * A URL safe, human readable unique identifier for the product.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  slug: Scalars['String'];
  /**
   * The title of the product.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  title: Scalars['String'];
  /**
   * The products html description to be shown on the web.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Any details about the products specifications in html.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  specifications?: Maybe<Scalars['String']>;
  /**
   * Comma separated list of keywords associated with the product.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  keywords?: Maybe<Scalars['String']>;
  /**
   * Product html information to be displayed with in the footer.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  footer?: Maybe<Scalars['String']>;
  /**
   * Is the product sellable, which means does it have offers with stock.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  sellable: Scalars['Boolean'];
  /**
   * Whether the product should be visible on the website.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  visible: Scalars['Boolean'];
  /**
   * Whether the product should display a from price tag (e.g. from $6.95).
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   * @deprecated Use priceTag.topLabel instead
   */
  fromPriceLabel: Scalars['Boolean'];
  /**
   * Information on how the price tag should be displayed
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  priceTag?: Maybe<PriceTag>;
  /** owner(tribe: "Digital", squad: "growth") */
  bestOffer?: Maybe<Offer>;
  /**
   * This is the best offer, or the selected offer if the variantId or offerId has been provided
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  selectedOffer?: Maybe<Offer>;
  /** owner(tribe: "Digital", squad: "growth") */
  brand?: Maybe<Brand>;
  /**
   * This is the customer category.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  category?: Maybe<Category>;
  /**
   * The customer collection of all the values for each option, which holds high level data about the product range,
   * including all of the options and all their possible values.
   * This data is used just for display and not mappable or representational of actual variants for sale.
   * 
   *     `owner(tribe: "Digital", squad: "growth")`
   */
  options: Array<ProductOption>;
  /** owner(tribe: "Digital", squad: "growth") */
  variants: Array<Variant>;
  /**
   * The products assets (images, videos, etc.)
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  assets: ProductAssets;
  /**
   * The ratings summary (average rating, the count of ratings)
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  ratingsSummary: RatingsSummary;
  /**
   * Determines whether product is considered sensitive and hidden from product feeds
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  sensitive: Scalars['Boolean'];
  /**
   * Determines if customer must be 18 years or over to purchase product (e.g. knives, alcohol, dangerous goods, etc.)
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  ageRestricted: Scalars['Boolean'];
  /**
   * Determines if customer must be 18 years or over in order to both view and purchase product
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  adult: Scalars['Boolean'];
  /**
   * Meta URLs for a product, usually for SEO purpose
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  metaURLs?: Maybe<MetaUrLs>;
  /**
   * Input fields for personalised products such as gift cards
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  personalisedFields: Array<PersonalisedField>;
};


/**
 * A customer-facing item or service that can be sold. Products contain information such as title, description, as well other generic high level data use to describe itself.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type ProductVisibleArgs = {
  input?: Maybe<VisibleInput>;
};


/**
 * A customer-facing item or service that can be sold. Products contain information such as title, description, as well other generic high level data use to describe itself.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type ProductSelectedOfferArgs = {
  input?: Maybe<SelectedOfferInput>;
};

/**
 * Product Assets. Containing a hero, gallery and size charts.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type ProductAssets = {
  __typename?: 'ProductAssets';
  /**
   * The primary asset of Product. The asset users see when viewing products in a list.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  hero: Image;
  /**
   * The gallery assets are visible on the Product page
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  gallery: Array<MediaAsset>;
  /**
   * Size chart assets which are used as size guides for customers
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  sizeCharts: Array<Image>;
};

export type ProductByIdInput = {
  id: Scalars['ID'];
};

/** The options and all their possible values which make up this product. */
export type ProductOption = {
  __typename?: 'ProductOption';
  id: Scalars['ID'];
  name: Scalars['String'];
  values: Array<ProductOptionValue>;
};

/** The values of each of the options which are in-use by a variant. */
export type ProductOptionValue = {
  __typename?: 'ProductOptionValue';
  id: Scalars['ID'];
  /** The name of the value */
  name: Scalars['String'];
  /** The option associated with this option value */
  option: ProductOption;
};

/**
 * Product disclaimer information for retail price
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type ProductRetailPriceDisclaimer = {
  __typename?: 'ProductRetailPriceDisclaimer';
  /** owner(tribe: "Digital", squad: "growth") */
  description: Scalars['String'];
};

export type ProductReview = {
  __typename?: 'ProductReview';
  id: Scalars['ID'];
  date: Scalars['String'];
  author: Scalars['String'];
  /** The rating score for this product review eg 4 */
  rating: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  helpful: HelpfulReview;
  /** The logged in customer is the author of this review */
  customerOwnsReview: Scalars['Boolean'];
};

/** owner(tribe: "Digital", squad: "growth") */
export type ProductReviews = {
  __typename?: 'ProductReviews';
  /** owner(tribe: "Digital", squad: "growth") */
  reviews: Array<ProductReview>;
};

export type ProductReviewsInput = {
  productId: Scalars['ID'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
};

/**
 * Warranty information associated with each product
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type ProductWarranty = {
  __typename?: 'ProductWarranty';
  /** owner(tribe: "Digital", squad: "growth") */
  type: ProductWarrantyType;
  /** owner(tribe: "Digital", squad: "growth") */
  description?: Maybe<Scalars['String']>;
};

/** Warranty information types */
export type ProductWarrantyType = 
  | 'CATCH'
  | 'MANUFACTURER'
  | 'DIRECT_IMPORT'
  | 'NONE';

/** Query root type */
export type Query = {
  __typename?: 'Query';
  placeholder?: Maybe<Scalars['String']>;
  bannerByPage?: Maybe<BannerByPageResponse>;
  liveBanners: LiveBannersResponse;
  /** Fetch the initial cart */
  initialBuyNowCart: UpdateBuyNowCartResponse;
  cart: Cart;
  brandById?: Maybe<Brand>;
  categoryById?: Maybe<Category>;
  productById?: Maybe<Product>;
  checkout: Checkout;
  /** Namespace for CMS configuration */
  cmsConfiguration: CmsConfiguration;
  /** All information belonging to the footer box */
  footer: Footer;
  /** @deprecated Use cmsConfiguration query instead */
  configuration: Configuration;
  textBlock?: Maybe<TextBlock>;
  couponsFromUser: CouponsPayload;
  couponByCode: CouponPayload;
  /** Get Customer information. Return null if customer can't be identified */
  customer?: Maybe<Customer>;
  existingCustomer: ExistingCustomerResponse;
  /** Fetches a list of matching location objects based on searchTerm, postcode or suburb provided */
  locationSuggestions: LocationSuggestionsResult;
  /** Get customer location information */
  userLocation: UserLocationResponse;
  eventBySlug: EventBySlugResponse;
  featuredProductsByEventId: FeaturedProductsByEventIdResponse;
  latestEvents: LatestEventsResponse;
  liveEvents: LiveEventsResponse;
  personalisedEvents: PersonalisedEventsResponse;
  popularEvents: PopularEventsResponse;
  experiments: ExperimentsPayload;
  christmasDelivery: ChristmasDeliveryResponse;
  /** Fetch the delivery estimate for an offer */
  deliveryEstimate: DeliveryEstimateOfferResponse;
  /** Fetch the delivery estimates for a product */
  deliveryEstimates: DeliveryEstimateProductResponse;
  myAccountMenu: MyAccountMenu;
  bestSellerProducts: BestSellerProductsResponse;
  brandRecommendedProducts: BrandRecommendedProductsResponse;
  cartCoPurchasedProducts: CartCoPurchasedProducts;
  /** Recommend a product to the user based on what items they have in their cart */
  cartUpsellRecommendation: CartUpsellResponse;
  categoryRecommendedProducts: CategoryRecommendedProductsResponse;
  coPurchasedProducts: CoPurchasedProducts;
  fomoProductRecommendations: FomoProductRecommendationsResponse;
  frequentlyBoughtTogether: FrequentlyBoughtTogetherResponse;
  onePassRecommendedProducts: OnePassRecommendedProductsResponse;
  peopleAlsoViewed: PeopleAlsoViewedResponse;
  personalisedRecommendedProducts: PersonalisedRecommendedProductsResponse;
  recentlyViewed: RecentlyViewedResponse;
  recommendedCategories: RecommendedCategoriesResponse;
  recommendedEvents: RecommendedEventsResponse;
  recommendedEventsV2: RecommendedEventsV2Response;
  sellerRecommendedProducts: SellerRecommendedProductsResponse;
  similarProducts: SimilarProductsResponse;
  topBrands: TopBrandsResponse;
  topBrandsPersonalised: TopBrandsResponse;
  topRatedProducts: TopRatedProductsResponse;
  trendingProducts: TrendingProductsResponse;
  productReviews?: Maybe<ProductReviews>;
  onePassScheduleEntryCategories: ScheduleEntryCategoriesResponse;
  onePassHeroEntries: ScheduleEntriesResponse;
  onePassUpcomingEntries: ScheduleEntriesResponse;
  onePassScheduleEntries: ScheduleEntriesResponse;
  /** @deprecated Use securityConfiguration query instead */
  security: Security;
  /** All frontend public security related configuration */
  securityConfiguration: Security;
  popularSearches: PopularSearches;
  shop?: Maybe<ShopResponse>;
};


/** Query root type */
export type QueryBannerByPageArgs = {
  input: BannerByPageInput;
};


/** Query root type */
export type QueryLiveBannersArgs = {
  input: LiveBannersInput;
};


/** Query root type */
export type QueryInitialBuyNowCartArgs = {
  offerId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  couponCode?: Maybe<Scalars['String']>;
  deliveryType?: Maybe<DeliveryType>;
  eventId?: Maybe<Scalars['Int']>;
  sourceId?: Maybe<Scalars['String']>;
  sourcePosition?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<Scalars['String']>;
  sourcePlatform?: Maybe<SourcePlatformType>;
};


/** Query root type */
export type QueryBrandByIdArgs = {
  input: BrandByIdInput;
};


/** Query root type */
export type QueryCategoryByIdArgs = {
  input: CategoryByIdInput;
};


/** Query root type */
export type QueryProductByIdArgs = {
  input: ProductByIdInput;
};


/** Query root type */
export type QueryTextBlockArgs = {
  input: TextBlockInput;
};


/** Query root type */
export type QueryCouponByCodeArgs = {
  input: CouponByCodeInput;
};


/** Query root type */
export type QueryExistingCustomerArgs = {
  input: ExistingCustomerInput;
};


/** Query root type */
export type QueryLocationSuggestionsArgs = {
  input?: Maybe<LocationSuggestionsInput>;
};


/** Query root type */
export type QueryUserLocationArgs = {
  deviceId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
};


/** Query root type */
export type QueryEventBySlugArgs = {
  input: EventBySlugInput;
};


/** Query root type */
export type QueryFeaturedProductsByEventIdArgs = {
  input: FeaturedProductsByEventIdInput;
};


/** Query root type */
export type QueryLatestEventsArgs = {
  input: LatestEventsInput;
};


/** Query root type */
export type QueryLiveEventsArgs = {
  input: LiveEventsInput;
};


/** Query root type */
export type QueryPersonalisedEventsArgs = {
  input: PersonalisedEventsInput;
};


/** Query root type */
export type QueryPopularEventsArgs = {
  input: PopularEventsInput;
};


/** Query root type */
export type QueryExperimentsArgs = {
  input: ExperimentsInput;
};


/** Query root type */
export type QueryChristmasDeliveryArgs = {
  input: ChristmasDeliveryInput;
};


/** Query root type */
export type QueryDeliveryEstimateArgs = {
  offerId: Scalars['ID'];
  postcode: Scalars['String'];
};


/** Query root type */
export type QueryDeliveryEstimatesArgs = {
  productId: Scalars['ID'];
  postcode: Scalars['String'];
};


/** Query root type */
export type QueryBestSellerProductsArgs = {
  input: BestSellerProductsInput;
};


/** Query root type */
export type QueryBrandRecommendedProductsArgs = {
  input: BrandRecommendedProductsInput;
};


/** Query root type */
export type QueryCartCoPurchasedProductsArgs = {
  input: CartCoPurchasedProductsInput;
};


/** Query root type */
export type QueryCartUpsellRecommendationArgs = {
  input: CartUpsellRecommendationInput;
};


/** Query root type */
export type QueryCategoryRecommendedProductsArgs = {
  input: CategoryRecommendedProductsInput;
};


/** Query root type */
export type QueryCoPurchasedProductsArgs = {
  input: CoPurchasedProductsInput;
};


/** Query root type */
export type QueryFomoProductRecommendationsArgs = {
  input?: Maybe<FomoProductRecommendationsInput>;
};


/** Query root type */
export type QueryFrequentlyBoughtTogetherArgs = {
  input: FrequentlyBoughtTogetherInput;
};


/** Query root type */
export type QueryOnePassRecommendedProductsArgs = {
  input: OnePassRecommendedProductsInput;
};


/** Query root type */
export type QueryPeopleAlsoViewedArgs = {
  input: PeopleAlsoViewedInput;
};


/** Query root type */
export type QueryPersonalisedRecommendedProductsArgs = {
  input: PersonalisedRecommendedProductsInput;
};


/** Query root type */
export type QueryRecentlyViewedArgs = {
  input: RecentlyViewedInput;
};


/** Query root type */
export type QueryRecommendedCategoriesArgs = {
  input: RecommendedCategoriesInput;
};


/** Query root type */
export type QueryRecommendedEventsArgs = {
  input: RecommendedEventsInput;
};


/** Query root type */
export type QueryRecommendedEventsV2Args = {
  input: RecommendedEventsV2Input;
};


/** Query root type */
export type QuerySellerRecommendedProductsArgs = {
  input: SellerRecommendedProductsInput;
};


/** Query root type */
export type QuerySimilarProductsArgs = {
  input: SimilarProductsInput;
};


/** Query root type */
export type QueryTopBrandsArgs = {
  input: TopBrandsInput;
};


/** Query root type */
export type QueryTopBrandsPersonalisedArgs = {
  input: TopBrandsInput;
};


/** Query root type */
export type QueryTopRatedProductsArgs = {
  input: TopRatedProductsInput;
};


/** Query root type */
export type QueryTrendingProductsArgs = {
  input: TrendingProductsInput;
};


/** Query root type */
export type QueryProductReviewsArgs = {
  input: ProductReviewsInput;
};


/** Query root type */
export type QueryOnePassScheduleEntriesArgs = {
  input?: Maybe<OnePassScheduleEntryInput>;
};


/** Query root type */
export type QueryPopularSearchesArgs = {
  input?: Maybe<PopularSearchesInput>;
};


/** Query root type */
export type QueryShopArgs = {
  input: ShopInput;
};

export type RatingBreakdown = {
  __typename?: 'RatingBreakdown';
  rating: Scalars['Int'];
  percentage: Scalars['Float'];
  total: Scalars['Int'];
};

/** owner(tribe: "Digital", squad: "growth") */
export type RatingsSummary = {
  __typename?: 'RatingsSummary';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "growth") */
  numberOfRatings: Scalars['Int'];
  /** owner(tribe: "Digital", squad: "growth") */
  averageRating?: Maybe<Scalars['Float']>;
  /** owner(tribe: "Digital", squad: "growth") */
  breakdown: Array<RatingBreakdown>;
};

export type RecentlyViewedInput = {
  maximumDaysSinceViewed?: Maybe<Scalars['Int']>;
  excludePurchasedProducts?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type RecentlyViewedResponse = {
  __typename?: 'RecentlyViewedResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

export type RecommendedCategoriesInput = {
  limit?: Maybe<Scalars['Int']>;
};

export type RecommendedCategoriesResponse = {
  __typename?: 'RecommendedCategoriesResponse';
  categories: Array<RecommendedCategory>;
  metaData: RecommenderMetaData;
};

export type RecommendedCategory = {
  __typename?: 'RecommendedCategory';
  id: Scalars['ID'];
  title: Scalars['String'];
  shopTitle: Scalars['String'];
  slug: Scalars['String'];
  shopSlug: Scalars['String'];
  link: Scalars['String'];
  recommendationSourceType: RecommendedCategorySourceType;
};

export type RecommendedCategorySourceType = 
  | 'TRENDING'
  | 'PERSONALISED';

export type RecommendedEventsInput = {
  productIds: Array<Scalars['ID']>;
  excludedEventIds?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
};

export type RecommendedEventsResponse = {
  __typename?: 'RecommendedEventsResponse';
  events: Array<Event>;
  metaData: RecommenderMetaData;
};

export type RecommendedEventsV2Input = {
  productIds: Array<Scalars['ID']>;
  excludedEventIds?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
};

export type RecommendedEventsV2Response = {
  __typename?: 'RecommendedEventsV2Response';
  events: Array<Event>;
  metaData: RecommenderMetaData;
};

/** This type hosts any metadata shared by the recommender queries */
export type RecommenderMetaData = {
  __typename?: 'RecommenderMetaData';
  postHydrationCount?: Maybe<Scalars['Int']>;
  preHydrationCount?: Maybe<Scalars['Int']>;
  hydrationErrorCount?: Maybe<Scalars['Int']>;
  /** Source product IDs required by personalised recommenders for tracking */
  sourceProductIds?: Maybe<Array<Scalars['Int']>>;
};

export type RecommenderPaginationData = {
  __typename?: 'RecommenderPaginationData';
  /** Total recommendations available */
  totalCount: Scalars['Int'];
  /** Reference to the available item */
  nextItemIndex: Scalars['Int'];
};

/**
 * Redeem gift card input
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type RedeemGiftCardInput = {
  /** Gift card code */
  code: Scalars['String'];
  /** Gift card pin code */
  pin: Scalars['String'];
};

export type RemoveFromWishlistItem = {
  __typename?: 'RemoveFromWishlistItem';
  id: Scalars['ID'];
};

/**
 * Remove gift card input
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type RemoveGiftCardFromCartInput = {
  /** Gift card code */
  code: Scalars['String'];
};

/**
 * Remove item from cart
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type RemoveItemFromCartInput = {
  /** CartParcelItem ID, this is ignored if an offerId is passed */
  itemId?: Maybe<Scalars['ID']>;
  offerId?: Maybe<Scalars['ID']>;
};

/** Remove item from wishlist input */
export type RemoveItemFromWishlistInput = {
  wishlistItemId: Scalars['ID'];
};

export type RemoveItemFromWishlistMutationResponse = RemoveFromWishlistItem | UserError;

export type RemoveSavedCardInput = {
  /** ID of the Credit Card to be removed */
  cardId: Scalars['ID'];
};

export type RemoveSavedCardResponse = {
  __typename?: 'RemoveSavedCardResponse';
  success: Scalars['Boolean'];
};

/** owner(tribe: "Digital", squad: "growth") */
export type SalesChannel = {
  __typename?: 'SalesChannel';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
};

/** owner(tribe: "Digital", squad: "conversion") */
export type SalesRule = {
  __typename?: 'SalesRule';
  /** owner(tribe: "Digital", squad: "conversion") */
  id: Scalars['ID'];
  /**
   * Sales rule description
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  shortDescription?: Maybe<Scalars['String']>;
  /**
   * Sales rule public description
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  longDescription?: Maybe<Scalars['String']>;
  /**
   * Sales rule public name
   * 
   * `owner(tribe: "Digital", squad: "conversion")`
   */
  name?: Maybe<Scalars['String']>;
};

export type ScheduleEntriesResponse = {
  __typename?: 'ScheduleEntriesResponse';
  entries: Array<ScheduleEntry>;
  ordinals?: Maybe<ScheduleEntryOrdinals>;
};

/** owner(tribe: "Digital", squad: "loyalty") */
export type ScheduleEntry = {
  __typename?: 'ScheduleEntry';
  /** owner(tribe: "Digital", squad: "loyalty") */
  id: Scalars['ID'];
  /**
   * The end date of the entry
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  endDate?: Maybe<Scalars['DateTime']>;
  /**
   * Event details of the entry
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  event?: Maybe<Event>;
  /**
   * Banner data for schedule entry with type of 'banner'
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  banner?: Maybe<Banner>;
  /**
   * Flag that indicates whether the entry is OnePass exclusive or not
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  onePassExclusive: Scalars['Boolean'];
  /**
   * The start date of the entry
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  startDate: Scalars['DateTime'];
};

export type ScheduleEntryCategoriesResponse = {
  __typename?: 'ScheduleEntryCategoriesResponse';
  categories: Array<ScheduleEntryCategory>;
};

/** owner(tribe: "Digital", squad: "loyalty") */
export type ScheduleEntryCategory = {
  __typename?: 'ScheduleEntryCategory';
  /** owner(tribe: "Digital", squad: "loyalty") */
  id: Scalars['ID'];
  /**
   * The label/name of the category
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  label: Scalars['String'];
  /**
   * Total entries count for the category
   * 
   * `owner(tribe: "Digital", squad: "loyalty")`
   */
  totalEntries: Scalars['Int'];
};

export type ScheduleEntryOrdinals = {
  __typename?: 'ScheduleEntryOrdinals';
  catchAppBanner?: Maybe<Scalars['Int']>;
  recentlyViewedProducts?: Maybe<Scalars['Int']>;
};

/** Name space for security configuration */
export type Security = {
  __typename?: 'Security';
  /** @deprecated Use more granular type instead */
  configuration?: Maybe<SecurityConfiguration>;
  /** Get frontend Kasada configuration */
  kasada: KasadaConfiguration;
};


/** Name space for security configuration */
export type SecurityKasadaArgs = {
  input: KasadaConfigurationInput;
};

export type SecurityConfiguration = {
  __typename?: 'SecurityConfiguration';
  kasada?: Maybe<KasadaConfiguration>;
};

export type SelectAddressInput = {
  addressId: Scalars['ID'];
};

export type SelectedOfferInput = {
  selectedVariantId?: Maybe<Scalars['ID']>;
  selectedOfferId?: Maybe<Scalars['ID']>;
};

/**
 * The owners of offers and organisation behind fulfilment of that offer, eg: Catch, Kmart, Agora Homewares.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type Seller = {
  __typename?: 'Seller';
  /**
   * ID of the seller
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  id: Scalars['ID'];
  /**
   * Title/name of the seller, eg: 'Catch', 'Agora Homewares', 'Matchbox Online'
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  name: Scalars['String'];
  /**
   * Slug used for the seller page
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * Information on the seller rating
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  rating?: Maybe<SellerRating>;
};

export type SellerBadge = 
  | 'PLATINUM'
  | 'GOLD'
  | 'SILVER'
  | 'BRONZE';

export type SellerRating = {
  __typename?: 'SellerRating';
  /** Rating percentage */
  percentage?: Maybe<Scalars['Float']>;
  /** Seller badge */
  badge?: Maybe<SellerBadge>;
};

export type SellerRecommendedProductsInput = {
  productId?: Maybe<Scalars['ID']>;
  excludedProductIds?: Maybe<Array<Scalars['ID']>>;
  amountLeftUntilFreeShipping?: Maybe<Scalars['Int']>;
  sellerId?: Maybe<Scalars['Int']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyOnePassEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type SellerRecommendedProductsResponse = {
  __typename?: 'SellerRecommendedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

export type SeoContent = {
  __typename?: 'SeoContent';
  /** The metadata title. */
  metaTitle?: Maybe<Scalars['String']>;
  /** The metadata description. */
  metaDescription?: Maybe<Scalars['String']>;
};

export type Shipping = {
  __typename?: 'Shipping';
  /** Flag if this offer is sold by Catch */
  soldByCatch: Scalars['Boolean'];
  /** Information about parcel dispatch such as dispatch type and expected date range */
  dispatchNotice?: Maybe<ShippingDispatchNotice>;
  /** Message to explain dropship information */
  dropshipDisclaimer?: Maybe<TemplateString>;
  /** One pass shipping disclaimer */
  onePassDisclaimer?: Maybe<TemplateString>;
  /** Free shipping disclaimer (tooltip) */
  freeShippingDisclaimer?: Maybe<Scalars['String']>;
  /** Physical location of this item eg Melbourne, VIC */
  itemLocation?: Maybe<Scalars['String']>;
};

export type ShippingDispatchNotice = {
  __typename?: 'ShippingDispatchNotice';
  /** Handles notices to be shown, eg: 'Leaves warehouse in 1-2 business days' */
  message: Scalars['String'];
  /** Shipping type to determine which label to display */
  type: ShippingDispatchNoticeType;
};

export type ShippingDispatchNoticeType = 
  | 'SPECIAL_ORDER'
  | 'IN_STOCK'
  | 'MARKETPLACE';

export type Shop = {
  __typename?: 'Shop';
  id: Scalars['Int'];
  slug: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
  pinToTop: Scalars['Boolean'];
  shopNavigationGroups: Array<ShopNavigationGroups>;
  topBrands: Array<NavigationItem>;
};

export type ShopInput = {
  id: Scalars['ID'];
};

export type ShopNavigationGroups = {
  __typename?: 'ShopNavigationGroups';
  id: Scalars['Int'];
  slug: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
  shopNavigationItems: Array<NavigationItem>;
};

/** owner(tribe: "Digital", squad: "loyalty") */
export type ShopResponse = {
  __typename?: 'ShopResponse';
  /** owner(tribe: "Digital", squad: "loyalty") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "loyalty") */
  name: Scalars['String'];
  /** owner(tribe: "Digital", squad: "loyalty") */
  slug: Scalars['String'];
  /** owner(tribe: "Digital", squad: "loyalty") */
  metaTitle?: Maybe<Scalars['String']>;
  /** owner(tribe: "Digital", squad: "loyalty") */
  metaDescription?: Maybe<Scalars['String']>;
};

export type SimilarProductsInput = {
  productId?: Maybe<Scalars['ID']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyClubCatchEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  /** A value that determines which data model to be used in fetching similar products */
  modelType?: Maybe<ModelType>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type SimilarProductsResponse = {
  __typename?: 'SimilarProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

/** Configuration used to connect to snowplow analytics */
export type SnowplowConfiguration = {
  __typename?: 'SnowplowConfiguration';
  collectorUrl: Scalars['String'];
  scriptSrc: Scalars['String'];
  appId: Scalars['String'];
  platform: SnowplowConfigurationPlatform;
  cookieDomain: Scalars['String'];
  eventMethod: Scalars['String'];
  pageUnloadTimer: Scalars['Int'];
  contexts: SnowplowConfigurationContexts;
};

/** Snowplow configuration context */
export type SnowplowConfigurationContexts = {
  __typename?: 'SnowplowConfigurationContexts';
  webPage: Scalars['Boolean'];
};

export type SnowplowConfigurationInput = {
  domain?: Maybe<Scalars['String']>;
};

/** Snowplow Platform */
export type SnowplowConfigurationPlatform = 
  | 'srv'
  | 'web'
  | 'mob'
  | 'pc'
  | 'app'
  | 'tv'
  | 'cnsl'
  | 'iot';

/** Options Available for SourcePlatform */
export type SourcePlatformType = 
  | 'DESKTOP'
  | 'MOBILE'
  | 'IPAD'
  | 'IPHONE'
  | 'ANDROID';

export type StockLevel = 
  | 'NONE'
  | 'LOW'
  | 'MEDIUM'
  | 'HIGH';

export type StoreCredit = {
  __typename?: 'StoreCredit';
  credit: Money;
  expiry?: Maybe<Scalars['DateTime']>;
};

/** A summary of store credit automatically applied to the Cart and any remaining balance */
export type StoreCreditSummary = {
  __typename?: 'StoreCreditSummary';
  applied: Money;
  remaining: Money;
};

/** Response for Buy Now Cart submit */
export type SubmitBuyNowCartResponse = SubmitBuyNowCartSuccess | UpdateBuyNowCartResponse;

/** Buy Now Cart success response */
export type SubmitBuyNowCartSuccess = {
  __typename?: 'SubmitBuyNowCartSuccess';
  orderId: Scalars['Int'];
};

/** A templated string for any notice */
export type TemplateString = {
  __typename?: 'TemplateString';
  /** Templated message eg. 'There are items in your cart that may incur additional {{ intl_shipping_link }}.' */
  template?: Maybe<Scalars['String']>;
  /** An array of placeholders used in the template */
  placeholders?: Maybe<Array<Maybe<TemplateStringPlaceholder>>>;
  /** Default string without template eg. 'There are items in your cart that may incur additional import charge.' */
  default: Scalars['String'];
};

/** Default replacement text for a TemplateString placeholder */
export type TemplateStringPlaceholder = {
  __typename?: 'TemplateStringPlaceholder';
  /** Example `intl_shipping_link` wrapped in {{}} in the template */
  id: Scalars['ID'];
  /** Text to replace the id, example 'International Seller & Import charges' */
  text: Scalars['String'];
  /** If id represents a link, this is the url of the link */
  url?: Maybe<Scalars['String']>;
};

/** Static content stored in the database */
export type TextBlock = {
  __typename?: 'TextBlock';
  key: Scalars['ID'];
  title: Scalars['String'];
  text: Scalars['String'];
};

export type TextBlockInput = {
  textBlockKey: Scalars['ID'];
};


export type ToggleDonationInput = {
  addDonation: Scalars['Boolean'];
};

export type TopBrandsInput = {
  limit?: Maybe<Scalars['Int']>;
};

export type TopBrandsResponse = {
  __typename?: 'TopBrandsResponse';
  brands: Array<Brand>;
  metaData: RecommenderMetaData;
};

/** Configuration for the top header bar above the main header */
export type TopHeaderConfiguration = {
  __typename?: 'TopHeaderConfiguration';
  leftSection: Array<TopHeaderLink>;
  rightSection: Array<TopHeaderLink>;
};

/** A link in the top header bar */
export type TopHeaderLink = {
  __typename?: 'TopHeaderLink';
  name: Scalars['String'];
  url: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  iconSize?: Maybe<Scalars['Int']>;
};

export type TopRatedProductsInput = {
  sellerId?: Maybe<Scalars['Int']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyOnePassEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
};

export type TopRatedProductsResponse = {
  __typename?: 'TopRatedProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

export type TrendingProductsInput = {
  productIds?: Maybe<Array<Scalars['ID']>>;
  sellerId?: Maybe<Scalars['Int']>;
  maximumPrice?: Maybe<Scalars['Int']>;
  includeAdultCategory?: Maybe<Scalars['Boolean']>;
  includeBulky?: Maybe<Scalars['Boolean']>;
  includeSpecialOrder?: Maybe<Scalars['Boolean']>;
  onlyOnePassEligible?: Maybe<Scalars['Boolean']>;
  inStock?: Maybe<Scalars['Boolean']>;
  hasAttribute?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
};

export type TrendingProductsResponse = {
  __typename?: 'TrendingProductsResponse';
  products: Array<Product>;
  metaData: RecommenderMetaData;
  pagination: RecommenderPaginationData;
};

/** Describes how the add to cart was triggered */
export type Trigger = 
  | 'BUY_NOW'
  | 'ADD_TO_CART';


/** Unauthorised user error type, which contain login link */
export type UnauthorisedUserError = Error & {
  __typename?: 'UnauthorisedUserError';
  message: Scalars['String'];
  /** Template that contain login link */
  messageOverride: TemplateString;
};

/** Request new cart */
export type UpdateBuyNowCartInput = {
  cartId: Scalars['ID'];
  offerId: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  couponCode?: Maybe<Scalars['String']>;
  giftCards?: Maybe<Array<RedeemGiftCardInput>>;
  deliveryType?: Maybe<DeliveryType>;
  /** Metadata for tracking the origin of the item in the cart */
  metadata?: Maybe<UpdateBuyNowCartMetadataInput>;
};

/**
 * Source metadata fields for Snowplow tracking representing the origin of the item in the cart.
 * These get stored on the cartItem to denote if the product came from Wishlist or Search or Product grid etc and the
 * position on the grid and platform etc where it originated.
 * 
 * As the BuyNowCart is stateless, the source metadata needs to be passed in on every update to the cart.
 */
export type UpdateBuyNowCartMetadataInput = {
  /** The ID of a tracking source, could be an int or a string in the case of search terms */
  sourceId?: Maybe<Scalars['String']>;
  /** The position the item is in a product grid */
  sourcePosition?: Maybe<Scalars['Int']>;
  /** The type of source tracking. See CartItem in CotdWebsite for full list of type ids */
  sourceType?: Maybe<Scalars['String']>;
  /** The platform id (an int) 1 = Web, 2 = Mobile Web etc. See CotdWebsite Platform entity */
  sourcePlatform?: Maybe<SourcePlatformType>;
  /** The ID of event this product is part of, when added to cart */
  eventId?: Maybe<Scalars['Int']>;
};

/** Response for Buy Now Cart update */
export type UpdateBuyNowCartResponse = {
  __typename?: 'UpdateBuyNowCartResponse';
  cart: Cart;
  errors: Array<BuyNowCartError>;
};

/**
 * Update Coupon in Cart
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type UpdateCartCouponInput = {
  code: Scalars['String'];
};

/**
 * Update the quantity of an item in the cart. If over purchaseLimit returns purchaseLimit as the quantity selected
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type UpdateCartItemQuantityInput = {
  /** CartParcelItem ID */
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

/**
 * Update cart location using either a postcode or location id
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type UpdateCartLocationInput = {
  locationId?: Maybe<Scalars['Int']>;
  postcode?: Maybe<Scalars['String']>;
};

/**
 * Update cart item product option
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type UpdateCartProductOptionInput = {
  /** CartParcelItem id */
  id: Scalars['ID'];
  /** Offer id */
  offerId: Scalars['ID'];
};

/**
 * Update cart shipping option input
 * 
 * `owner(tribe: "Digital", squad: "conversion")`
 */
export type UpdateCartShippingOptionInput = {
  /** CartParcelShippingOption type */
  type: DeliveryType;
};

/** Error response after updating user location */
export type UpdateUserLocationErrorResponse = {
  __typename?: 'UpdateUserLocationErrorResponse';
  locationId?: Maybe<Scalars['ID']>;
  error: UserLocationError;
};

/** Update user location input */
export type UpdateUserLocationInput = {
  /** Location (postcode) ID to update user location with */
  locationId?: Maybe<Scalars['ID']>;
};

export type UpdateUserLocationResponse = UpdateUserLocationSuccessResponse | UpdateUserLocationErrorResponse;

/** Success response after updating user location */
export type UpdateUserLocationSuccessResponse = {
  __typename?: 'UpdateUserLocationSuccessResponse';
  location: LocationResult;
};

/** Generic user interface */
export type User = {
  /** User UUID */
  id: Scalars['ID'];
  /** First name of user */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of user */
  lastName?: Maybe<Scalars['String']>;
  /** Email address of user */
  email: Scalars['EmailAddress'];
};

/** Generic user error type */
export type UserError = Error & {
  __typename?: 'UserError';
  message: Scalars['String'];
};

export type UserLocationError = Error & {
  __typename?: 'UserLocationError';
  code: UserLocationErrorCode;
  status: Scalars['Int'];
  message: Scalars['String'];
};

export type UserLocationErrorCode = 
  | 'ERROR';

/** Error response for the user location result */
export type UserLocationErrorResponse = {
  __typename?: 'UserLocationErrorResponse';
  deviceId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
  error: UserLocationError;
};

/** Response for the userLocation query */
export type UserLocationResponse = UserLocationSuccessResponse | UserLocationErrorResponse;

/** Success response for the userLocation query */
export type UserLocationSuccessResponse = {
  __typename?: 'UserLocationSuccessResponse';
  deviceId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
  location?: Maybe<LocationResult>;
};

/**
 * A variant of a product, as each product can have one or more options, a variant is a specific permutation of the options available. ie. a variant of a golf driver may be : Left handed, 43 inch, Graphite Shaft while another might be right handed, 43 inch, steel shaft.
 * 
 * `owner(tribe: "Digital", squad: "growth")`
 */
export type Variant = {
  __typename?: 'Variant';
  /** owner(tribe: "Digital", squad: "growth") */
  id: Scalars['ID'];
  /** owner(tribe: "Digital", squad: "growth") */
  product: Product;
  /**
   * If the variant has offers which are in stock and available for sale.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  sellable: Scalars['Boolean'];
  /**
   * The remaining quantity of a variant - value is null if it exceeds the threshold for display
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  limitedQuantityRemaining?: Maybe<Scalars['Int']>;
  /**
   * Each of the options for the product with the selected value for this variant.
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  variantOptionValues: Array<ProductOptionValue>;
  /** owner(tribe: "Digital", squad: "growth") */
  offers: Array<Offer>;
  /**
   * owner(tribe: "Digital", squad: "growth")
   * @deprecated Use `wishlist.inWishlist` instead.
   */
  inWishlist: Scalars['Boolean'];
  /** owner(tribe: "Digital", squad: "growth") */
  wishlist: VariantWishlist;
  /** owner(tribe: "Digital", squad: "growth") */
  bestOffer?: Maybe<Offer>;
  /**
   * Information on how the price tag should be displayed
   * 
   * `owner(tribe: "Digital", squad: "growth")`
   */
  priceTag?: Maybe<PriceTag>;
};

export type VariantWishlist = {
  __typename?: 'VariantWishlist';
  /** Is Variant in the users wishlist */
  inWishlist: Scalars['Boolean'];
  /** Full wishlist item including notify */
  wishlistItem?: Maybe<WishlistItem>;
};

/** A video type MediaAsset */
export type Video = MediaAsset & {
  __typename?: 'Video';
  id: Scalars['ID'];
  altText: Scalars['String'];
  /** Currently only YouTube URLs */
  url: Scalars['URL'];
};

export type VisibleInput = {
  previewHash?: Maybe<Scalars['String']>;
};

export type WishlistItem = {
  __typename?: 'WishlistItem';
  id: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  variantId?: Maybe<Scalars['ID']>;
  notify?: Maybe<Scalars['Boolean']>;
};

export type WishlistItemMutationResponse = WishlistItem | UserError;

export type CustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerQuery = (
  { __typename?: 'Query' }
  & { customer?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id' | 'displayName' | 'email'>
    & { club?: Maybe<(
      { __typename?: 'ClubCustomerSubscription' }
      & Pick<ClubCustomerSubscription, 'active' | 'onFreeTrial' | 'freeTrialEligible'>
    )>, membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'id' | 'linked' | 'doubleSubscription' | 'eligibleForMigration'>
      & { subscription?: Maybe<(
        { __typename?: 'MembershipSubscriptionDetails' }
        & Pick<MembershipSubscriptionDetails, 'active' | 'activeDaysRemaining' | 'autoRenewing' | 'freeTrialEligible' | 'interval' | 'latestMembershipPeriodEnd' | 'onFreeTrial' | 'purchasePrice' | 'freeTrialDaysRemaining' | 'isTeamMember'>
      )> }
    )>, storeCredit: (
      { __typename?: 'StoreCredit' }
      & Pick<StoreCredit, 'expiry'>
      & { credit: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    ), metaData: (
      { __typename?: 'CustomerMetaData' }
      & Pick<CustomerMetaData, 'customerUuid'>
    ) }
  )> }
);

export type GetKasadaConfigurationQueryVariables = Exact<{
  domain: Scalars['String'];
}>;


export type GetKasadaConfigurationQuery = (
  { __typename?: 'Query' }
  & { securityConfiguration: (
    { __typename?: 'Security' }
    & { kasada: (
      { __typename?: 'KasadaConfiguration' }
      & Pick<KasadaConfiguration, 'scriptUrl'>
      & { protectedEndpoints: Array<Maybe<(
        { __typename?: 'KasadaProtectedEndpoints' }
        & Pick<KasadaProtectedEndpoints, 'path' | 'domain' | 'method'>
      )>> }
    ) }
  ) }
);

export type BannerByPageQueryVariables = Exact<{
  input: BannerByPageInput;
}>;


export type BannerByPageQuery = (
  { __typename?: 'Query' }
  & { bannerByPage?: Maybe<(
    { __typename?: 'BannerByPageResponse' }
    & { banners: Array<(
      { __typename?: 'Banner' }
      & Pick<Banner, 'id' | 'url' | 'platforms'>
      & { image: (
        { __typename?: 'Image' }
        & Pick<Image, 'url' | 'altText' | 'height' | 'width'>
      ) }
    )> }
  )> }
);

export type CartContextQueryVariables = Exact<{ [key: string]: never; }>;


export type CartContextQuery = (
  { __typename?: 'Query' }
  & { cart: (
    { __typename?: 'Cart' }
    & { orderSummary: (
      { __typename?: 'CartOrderSummary' }
      & { itemSummary: (
        { __typename?: 'OrderSummaryItems' }
        & { items: Array<(
          { __typename?: 'CartParcelItem' }
          & Pick<CartParcelItem, 'id'>
          & { offer: (
            { __typename?: 'Offer' }
            & { variant: (
              { __typename?: 'Variant' }
              & { product: (
                { __typename?: 'Product' }
                & Pick<Product, 'id'>
              ) }
            ) }
          ) }
        )> }
      ), totalPrice: (
        { __typename?: 'Money' }
        & Pick<Money, 'amount'>
      ) }
    ) }
  ) }
);

export type MembershipQueryVariables = Exact<{ [key: string]: never; }>;


export type MembershipQuery = (
  { __typename?: 'Query' }
  & { customer?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id'>
    & { membership?: Maybe<(
      { __typename?: 'Membership' }
      & Pick<Membership, 'id' | 'linked'>
      & { subscription?: Maybe<(
        { __typename?: 'MembershipSubscriptionDetails' }
        & Pick<MembershipSubscriptionDetails, 'freeTrialEligible'>
      )> }
    )> }
  )> }
);

export type PageConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type PageConfigurationQuery = (
  { __typename?: 'Query' }
  & { cmsConfiguration: (
    { __typename?: 'CMSConfiguration' }
    & { page: (
      { __typename?: 'PageConfiguration' }
      & Pick<PageConfiguration, 'itunesAppUrl' | 'footerItunesAppUrl' | 'homeUspItunesAppUrl' | 'googlePlayUrl' | 'footerGooglePlayUrl' | 'homeUspGooglePlayUrl'>
    ) }
  ) }
);

export type AddItemToWishListMutationVariables = Exact<{
  variantId: Scalars['ID'];
  notify?: Maybe<Scalars['Boolean']>;
}>;


export type AddItemToWishListMutation = (
  { __typename?: 'Mutation' }
  & { addItemToWishlist: (
    { __typename?: 'WishlistItem' }
    & Pick<WishlistItem, 'id' | 'productId' | 'variantId' | 'notify'>
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) }
);

export type RemoveItemFromWishListMutationVariables = Exact<{
  wishlistItemId: Scalars['ID'];
}>;


export type RemoveItemFromWishListMutation = (
  { __typename?: 'Mutation' }
  & { removeItemFromWishlist: (
    { __typename?: 'RemoveFromWishlistItem' }
    & Pick<RemoveFromWishlistItem, 'id'>
  ) | (
    { __typename?: 'UserError' }
    & Pick<UserError, 'message'>
  ) }
);


export const CustomerDocument = gql`
    query Customer {
  customer {
    id
    displayName
    email
    club {
      active
      onFreeTrial
      freeTrialEligible
    }
    membership {
      id
      linked
      doubleSubscription
      eligibleForMigration
      subscription {
        active
        activeDaysRemaining
        autoRenewing
        freeTrialEligible
        interval
        latestMembershipPeriodEnd
        onFreeTrial
        purchasePrice
        freeTrialDaysRemaining
        isTeamMember
      }
    }
    storeCredit {
      credit {
        amount
      }
      expiry
    }
    metaData {
      customerUuid
    }
  }
}
    `;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, baseOptions);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, baseOptions);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const GetKasadaConfigurationDocument = gql`
    query GetKasadaConfiguration($domain: String!) {
  securityConfiguration {
    kasada(input: {domain: $domain}) {
      scriptUrl
      protectedEndpoints {
        path
        domain
        method
      }
    }
  }
}
    `;

/**
 * __useGetKasadaConfigurationQuery__
 *
 * To run a query within a React component, call `useGetKasadaConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKasadaConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKasadaConfigurationQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetKasadaConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetKasadaConfigurationQuery, GetKasadaConfigurationQueryVariables>) {
        return Apollo.useQuery<GetKasadaConfigurationQuery, GetKasadaConfigurationQueryVariables>(GetKasadaConfigurationDocument, baseOptions);
      }
export function useGetKasadaConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKasadaConfigurationQuery, GetKasadaConfigurationQueryVariables>) {
          return Apollo.useLazyQuery<GetKasadaConfigurationQuery, GetKasadaConfigurationQueryVariables>(GetKasadaConfigurationDocument, baseOptions);
        }
export type GetKasadaConfigurationQueryHookResult = ReturnType<typeof useGetKasadaConfigurationQuery>;
export type GetKasadaConfigurationLazyQueryHookResult = ReturnType<typeof useGetKasadaConfigurationLazyQuery>;
export type GetKasadaConfigurationQueryResult = Apollo.QueryResult<GetKasadaConfigurationQuery, GetKasadaConfigurationQueryVariables>;
export const BannerByPageDocument = gql`
    query BannerByPage($input: BannerByPageInput!) {
  bannerByPage(input: $input) {
    banners {
      id
      url
      platforms
      image {
        url
        altText
        height
        width
      }
    }
  }
}
    `;

/**
 * __useBannerByPageQuery__
 *
 * To run a query within a React component, call `useBannerByPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerByPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerByPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBannerByPageQuery(baseOptions?: Apollo.QueryHookOptions<BannerByPageQuery, BannerByPageQueryVariables>) {
        return Apollo.useQuery<BannerByPageQuery, BannerByPageQueryVariables>(BannerByPageDocument, baseOptions);
      }
export function useBannerByPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BannerByPageQuery, BannerByPageQueryVariables>) {
          return Apollo.useLazyQuery<BannerByPageQuery, BannerByPageQueryVariables>(BannerByPageDocument, baseOptions);
        }
export type BannerByPageQueryHookResult = ReturnType<typeof useBannerByPageQuery>;
export type BannerByPageLazyQueryHookResult = ReturnType<typeof useBannerByPageLazyQuery>;
export type BannerByPageQueryResult = Apollo.QueryResult<BannerByPageQuery, BannerByPageQueryVariables>;
export const CartContextDocument = gql`
    query CartContext {
  cart {
    orderSummary {
      itemSummary {
        items {
          id
          offer {
            variant {
              product {
                id
              }
            }
          }
        }
      }
      totalPrice {
        amount
      }
    }
  }
}
    `;

/**
 * __useCartContextQuery__
 *
 * To run a query within a React component, call `useCartContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartContextQuery(baseOptions?: Apollo.QueryHookOptions<CartContextQuery, CartContextQueryVariables>) {
        return Apollo.useQuery<CartContextQuery, CartContextQueryVariables>(CartContextDocument, baseOptions);
      }
export function useCartContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartContextQuery, CartContextQueryVariables>) {
          return Apollo.useLazyQuery<CartContextQuery, CartContextQueryVariables>(CartContextDocument, baseOptions);
        }
export type CartContextQueryHookResult = ReturnType<typeof useCartContextQuery>;
export type CartContextLazyQueryHookResult = ReturnType<typeof useCartContextLazyQuery>;
export type CartContextQueryResult = Apollo.QueryResult<CartContextQuery, CartContextQueryVariables>;
export const MembershipDocument = gql`
    query Membership {
  customer {
    id
    membership {
      id
      linked
      subscription {
        freeTrialEligible
      }
    }
  }
}
    `;

/**
 * __useMembershipQuery__
 *
 * To run a query within a React component, call `useMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipQuery(baseOptions?: Apollo.QueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
        return Apollo.useQuery<MembershipQuery, MembershipQueryVariables>(MembershipDocument, baseOptions);
      }
export function useMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipQuery, MembershipQueryVariables>) {
          return Apollo.useLazyQuery<MembershipQuery, MembershipQueryVariables>(MembershipDocument, baseOptions);
        }
export type MembershipQueryHookResult = ReturnType<typeof useMembershipQuery>;
export type MembershipLazyQueryHookResult = ReturnType<typeof useMembershipLazyQuery>;
export type MembershipQueryResult = Apollo.QueryResult<MembershipQuery, MembershipQueryVariables>;
export const PageConfigurationDocument = gql`
    query PageConfiguration {
  cmsConfiguration {
    page {
      itunesAppUrl
      footerItunesAppUrl
      homeUspItunesAppUrl
      googlePlayUrl
      footerGooglePlayUrl
      homeUspGooglePlayUrl
    }
  }
}
    `;

/**
 * __usePageConfigurationQuery__
 *
 * To run a query within a React component, call `usePageConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePageConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<PageConfigurationQuery, PageConfigurationQueryVariables>) {
        return Apollo.useQuery<PageConfigurationQuery, PageConfigurationQueryVariables>(PageConfigurationDocument, baseOptions);
      }
export function usePageConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageConfigurationQuery, PageConfigurationQueryVariables>) {
          return Apollo.useLazyQuery<PageConfigurationQuery, PageConfigurationQueryVariables>(PageConfigurationDocument, baseOptions);
        }
export type PageConfigurationQueryHookResult = ReturnType<typeof usePageConfigurationQuery>;
export type PageConfigurationLazyQueryHookResult = ReturnType<typeof usePageConfigurationLazyQuery>;
export type PageConfigurationQueryResult = Apollo.QueryResult<PageConfigurationQuery, PageConfigurationQueryVariables>;
export const AddItemToWishListDocument = gql`
    mutation AddItemToWishList($variantId: ID!, $notify: Boolean) {
  addItemToWishlist(input: {variantId: $variantId, notify: $notify}) {
    ... on WishlistItem {
      id
      productId
      variantId
      notify
    }
    ... on UserError {
      message
    }
  }
}
    `;
export type AddItemToWishListMutationFn = Apollo.MutationFunction<AddItemToWishListMutation, AddItemToWishListMutationVariables>;

/**
 * __useAddItemToWishListMutation__
 *
 * To run a mutation, you first call `useAddItemToWishListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToWishListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToWishListMutation, { data, loading, error }] = useAddItemToWishListMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *      notify: // value for 'notify'
 *   },
 * });
 */
export function useAddItemToWishListMutation(baseOptions?: Apollo.MutationHookOptions<AddItemToWishListMutation, AddItemToWishListMutationVariables>) {
        return Apollo.useMutation<AddItemToWishListMutation, AddItemToWishListMutationVariables>(AddItemToWishListDocument, baseOptions);
      }
export type AddItemToWishListMutationHookResult = ReturnType<typeof useAddItemToWishListMutation>;
export type AddItemToWishListMutationResult = Apollo.MutationResult<AddItemToWishListMutation>;
export type AddItemToWishListMutationOptions = Apollo.BaseMutationOptions<AddItemToWishListMutation, AddItemToWishListMutationVariables>;
export const RemoveItemFromWishListDocument = gql`
    mutation RemoveItemFromWishList($wishlistItemId: ID!) {
  removeItemFromWishlist(input: {wishlistItemId: $wishlistItemId}) {
    ... on RemoveFromWishlistItem {
      id
    }
    ... on UserError {
      message
    }
  }
}
    `;
export type RemoveItemFromWishListMutationFn = Apollo.MutationFunction<RemoveItemFromWishListMutation, RemoveItemFromWishListMutationVariables>;

/**
 * __useRemoveItemFromWishListMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromWishListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromWishListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromWishListMutation, { data, loading, error }] = useRemoveItemFromWishListMutation({
 *   variables: {
 *      wishlistItemId: // value for 'wishlistItemId'
 *   },
 * });
 */
export function useRemoveItemFromWishListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveItemFromWishListMutation, RemoveItemFromWishListMutationVariables>) {
        return Apollo.useMutation<RemoveItemFromWishListMutation, RemoveItemFromWishListMutationVariables>(RemoveItemFromWishListDocument, baseOptions);
      }
export type RemoveItemFromWishListMutationHookResult = ReturnType<typeof useRemoveItemFromWishListMutation>;
export type RemoveItemFromWishListMutationResult = Apollo.MutationResult<RemoveItemFromWishListMutation>;
export type RemoveItemFromWishListMutationOptions = Apollo.BaseMutationOptions<RemoveItemFromWishListMutation, RemoveItemFromWishListMutationVariables>;